// Reinitialise native guide interactions safely after Shopify section edits.
(()=>{
 let controller, timers=[], intervals=[], observers=[];
 function init(){
  controller?.abort();timers.forEach(clearTimeout);intervals.forEach(clearInterval);observers.forEach(o=>o.disconnect());
  controller=new AbortController();timers=[];intervals=[];observers=[];
  const bgListen=(el,event,callback,options={})=>el.addEventListener(event,callback,{...(typeof options==='boolean'?{capture:options}:options),signal:controller.signal});
  const bgTimeout=(fn,delay)=>{const id=window.setTimeout(fn,delay);timers.push(id);return id};
  const bgInterval=(fn,delay)=>{const id=window.setInterval(fn,delay);intervals.push(id);return id};
  const bgObserver=(fn,options)=>{const observer=new IntersectionObserver(fn,options);observers.push(observer);return observer};
/* ==========================================================
   RENEORA BEAUTY GUIDE
   PREMIUM COMPLEXION EXPERIENCE
========================================================== */

(() => {

    const complexion =
        document.querySelector(
            "[data-premium-complexion]"
        );


    /* -------------------------------------------------------
       EXIT IF BEAUTY GUIDE IS NOT ON THIS PAGE
    ------------------------------------------------------- */

    if (!complexion) {
        return;
    }



    /* ======================================================
       01 — COMPLEXION MAIN TABS
       Overview / Placement / Technique / Result / Watch
    ====================================================== */

    const tabs =
        Array.from(
            complexion.querySelectorAll(
                "[data-complexion-tab]"
            )
        );


    const panels =
        Array.from(
            complexion.querySelectorAll(
                "[data-complexion-panel]"
            )
        );


    /* ==========================================================
   RENEORA PREMIUM SCENE SHIFT
   Overview / Placement / Technique / Result / Watch
========================================================== */

let complexionSceneTransitioning =
    false;


let queuedComplexionTab =
    null;


function activateComplexionTab(
    tabName,
    options = {}
) {

    const {
        focus = false,
        scrollTab = false
    } = options;


    const panelsStage =
        complexion.querySelector(
            ".bgp-complexion-panels"
        );


    const nextPanel =
        panels.find(
            (panel) =>
                panel.dataset.complexionPanel ===
                tabName
        );


    if (!nextPanel) {
        return;
    }



    /* ======================================================
       UPDATE TAB BUTTONS
    ====================================================== */

    tabs.forEach((tab) => {

        const isActive =
            tab.dataset.complexionTab ===
            tabName;


        tab.classList.toggle(
            "is-active",
            isActive
        );


        tab.setAttribute(
            "aria-selected",
            isActive
                ? "true"
                : "false"
        );


        tab.tabIndex =
            isActive
                ? 0
                : -1;


        if (
            isActive &&
            focus
        ) {

            tab.focus({
                preventScroll: true
            });

        }


        if (
            isActive &&
            scrollTab
        ) {

            tab.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });

        }

    });



    /* ======================================================
       CURRENT PANEL
    ====================================================== */

    const currentPanel =
        panels.find(
            (panel) =>
                !panel.hidden &&
                panel.classList.contains(
                    "is-active"
                )
        ) ||
        panels.find(
            (panel) =>
                !panel.hidden
        );



    /*
       Initial page load or clicking
       the already-active tab.
    */

    if (
        !currentPanel ||
        currentPanel === nextPanel
    ) {

        panels.forEach((panel) => {

            const isActive =
                panel === nextPanel;


            panel.hidden =
                !isActive;


            panel.classList.toggle(
                "is-active",
                isActive
            );


            panel.setAttribute(
                "aria-hidden",
                isActive
                    ? "false"
                    : "true"
            );

        });


        return;
    }



    /* ======================================================
       IF ANOTHER TRANSITION IS RUNNING
    ====================================================== */

    if (complexionSceneTransitioning) {

        queuedComplexionTab =
            tabName;

        return;
    }



    complexionSceneTransitioning =
        true;



    /* ======================================================
       DIRECTION
    ====================================================== */

    const currentIndex =
        panels.indexOf(
            currentPanel
        );


    const nextIndex =
        panels.indexOf(
            nextPanel
        );


    const direction =
        nextIndex > currentIndex
            ? "forward"
            : "backward";



    /* ======================================================
       REDUCED MOTION
    ====================================================== */

    const reduceMotion =
        window.matchMedia(
            "(prefers-reduced-motion: reduce)"
        ).matches;


    if (
        reduceMotion ||
        !panelsStage
    ) {

        currentPanel.hidden = true;

        currentPanel.classList.remove(
            "is-active"
        );


        currentPanel.setAttribute(
            "aria-hidden",
            "true"
        );


        nextPanel.hidden = false;

        nextPanel.classList.add(
            "is-active"
        );


        nextPanel.setAttribute(
            "aria-hidden",
            "false"
        );


        complexionSceneTransitioning =
            false;


        return;

    }



    /* ======================================================
       MEASURE OLD PANEL
    ====================================================== */

    const currentHeight =
        currentPanel.offsetHeight;



    /* ======================================================
       PREPARE NEW PANEL
    ====================================================== */

    nextPanel.hidden = false;


    nextPanel.setAttribute(
        "aria-hidden",
        "false"
    );


    /*
       Temporarily make it measurable
       without flashing on screen.
    */

    nextPanel.style.visibility =
        "hidden";


    const nextHeight =
        nextPanel.offsetHeight;


    nextPanel.style.visibility =
        "";



    /*
       Keep stage height stable while
       both panels occupy the same place.
    */

    panelsStage.style.height =
        `${Math.max(
            currentHeight,
            nextHeight
        )}px`;


    panelsStage.classList.add(
        "is-scene-transitioning"
    );



    /* ======================================================
       ASSIGN 3D ROLES
    ====================================================== */

    currentPanel.classList.remove(
        "is-active"
    );


    currentPanel.classList.add(
        "is-scene-layer",
        "is-scene-leaving",
        `is-scene-${direction}`
    );


    nextPanel.classList.add(
        "is-scene-layer",
        "is-scene-entering",
        `is-scene-${direction}`
    );



    /* ======================================================
       PAUSE VIDEO IF LEAVING WATCH
    ====================================================== */

    currentPanel
        .querySelectorAll(
            "video"
        )
        .forEach((video) => {

            video.pause();

        });



    /* ======================================================
       FORCE INITIAL 3D STATE
    ====================================================== */

    void panelsStage.offsetWidth;



    /* ======================================================
       PLAY
    ====================================================== */

    requestAnimationFrame(() => {

        requestAnimationFrame(() => {

            panelsStage.classList.add(
                "is-scene-playing"
            );

        });

    });



    /* ======================================================
       FINISH
    ====================================================== */

    bgTimeout(
        () => {

            currentPanel.hidden =
                true;


            currentPanel.setAttribute(
                "aria-hidden",
                "true"
            );


            currentPanel.classList.remove(
                "is-scene-layer",
                "is-scene-leaving",
                "is-scene-forward",
                "is-scene-backward"
            );


            nextPanel.classList.remove(
                "is-scene-layer",
                "is-scene-entering",
                "is-scene-forward",
                "is-scene-backward"
            );


            nextPanel.classList.add(
                "is-active"
            );


            panelsStage.classList.remove(
                "is-scene-transitioning",
                "is-scene-playing"
            );


            panelsStage.style.height =
                "";


            complexionSceneTransitioning =
                false;



            /* ==============================================
               RUN LAST REQUESTED TAB
               IF USER CLICKED QUICKLY
            ============================================== */

            if (queuedComplexionTab) {

                const queued =
                    queuedComplexionTab;


                queuedComplexionTab =
                    null;


                if (
                    queued !==
                    nextPanel.dataset.complexionPanel
                ) {

                    activateComplexionTab(
                        queued
                    );

                }

            }

        },
        400
    );

}



    /* ======================================================
       TAB CLICK
    ====================================================== */

    tabs.forEach((tab) => {

        bgListen(tab,
            "click",
            () => {

                activateComplexionTab(
                    tab.dataset.complexionTab,
                    {
                        scrollTab: true
                    }
                );

            }
        );

    });



    /* ======================================================
       TAB KEYBOARD NAVIGATION
       Arrow Left / Right
    ====================================================== */

    tabs.forEach(
        (tab, index) => {

            bgListen(tab,
                "keydown",
                (event) => {

                    let nextIndex = null;


                    if (
                        event.key ===
                        "ArrowRight"
                    ) {

                        nextIndex =
                            (
                                index + 1
                            ) %
                            tabs.length;

                    }


                    if (
                        event.key ===
                        "ArrowLeft"
                    ) {

                        nextIndex =
                            (
                                index - 1 +
                                tabs.length
                            ) %
                            tabs.length;

                    }


                    if (
                        event.key ===
                        "Home"
                    ) {

                        nextIndex = 0;

                    }


                    if (
                        event.key ===
                        "End"
                    ) {

                        nextIndex =
                            tabs.length - 1;

                    }


                    if (
                        nextIndex ===
                        null
                    ) {
                        return;
                    }


                    event.preventDefault();


                    activateComplexionTab(
                        tabs[
                            nextIndex
                        ].dataset.complexionTab,
                        {
                            focus: true,
                            scrollTab: true
                        }
                    );

                }
            );

        }
    );



    /* ======================================================
       INITIAL STATE
    ====================================================== */

    const initialTab =
        tabs.find(
            (tab) =>
                tab.classList.contains(
                    "is-active"
                )
        ) ||
        tabs[0];


    if (initialTab) {

        activateComplexionTab(
            initialTab.dataset.complexionTab
        );

    }



    /* ======================================================
       02 — INTERACTIVE PLACEMENT GUIDE
       Points 01 / 02 / 03 / 04
    ====================================================== */

    const placementPins =
        Array.from(
            complexion.querySelectorAll(
                "[data-placement-target]"
            )
        );

        const placementImages =
    Array.from(
        complexion.querySelectorAll(
            "[data-placement-image]"
        )
    );


let placementImageTransitioning =
    false;


let queuedPlacement =
    null;

    const placementCopies =
        Array.from(
            complexion.querySelectorAll(
                "[data-placement-copy]"
            )
        );


    function activatePlacement(
    placementName
) {

    const nextImage =
        placementImages.find(
            (image) =>
                image.dataset.placementImage ===
                placementName
        );


    const nextCopy =
        placementCopies.find(
            (copy) =>
                copy.dataset.placementCopy ===
                placementName
        );


    if (
        !nextImage ||
        !nextCopy
    ) {
        return;
    }



    const currentImage =
        placementImages.find(
            (image) =>
                image.classList.contains(
                    "is-active"
                )
        );


    const currentCopy =
        placementCopies.find(
            (copy) =>
                copy.classList.contains(
                    "is-active"
                ) &&
                !copy.hidden
        );



    /* ======================================================
       SAME ITEM / INITIAL STATE
    ====================================================== */

    if (
        !currentImage ||
        currentImage === nextImage
    ) {

        placementPins.forEach(
            (pin) => {

                const active =
                    pin.dataset.placementTarget ===
                    placementName;


                pin.classList.toggle(
                    "is-active",
                    active
                );


                pin.setAttribute(
                    "aria-pressed",
                    active
                        ? "true"
                        : "false"
                );

            }
        );


        placementImages.forEach(
            (image) => {

                image.classList.toggle(
                    "is-active",
                    image === nextImage
                );

            }
        );


        placementCopies.forEach(
            (copy) => {

                const active =
                    copy === nextCopy;


                copy.hidden =
                    !active;


                copy.classList.toggle(
                    "is-active",
                    active
                );

            }
        );


        return;
    }



    /* ======================================================
       IF USER CLICKS DURING ANIMATION
    ====================================================== */

    if (placementImageTransitioning) {

        queuedPlacement =
            placementName;

        return;
    }


    placementImageTransitioning =
        true;



    /* ======================================================
       ACTIVE NUMBER
    ====================================================== */

    placementPins.forEach(
        (pin) => {

            const active =
                pin.dataset.placementTarget ===
                placementName;


            pin.classList.toggle(
                "is-active",
                active
            );


            pin.setAttribute(
                "aria-pressed",
                active
                    ? "true"
                    : "false"
            );

        }
    );



    /* ======================================================
       DIRECTION
    ====================================================== */

    const currentIndex =
        placementImages.indexOf(
            currentImage
        );


    const nextIndex =
        placementImages.indexOf(
            nextImage
        );


    const forward =
        nextIndex >
        currentIndex;



    /* ======================================================
       PREPARE NEXT COPY
    ====================================================== */

    nextCopy.hidden =
        false;


    nextCopy.classList.add(
        "is-active"
    );



    /* ======================================================
       IMAGE 3D MOTION
    ====================================================== */

    const outgoingTransform =
        forward
            ? `
                translate3d(
                    -12%,
                    0,
                    -105px
                )
                rotateY(7deg)
                scale(.96)
              `
            : `
                translate3d(
                    12%,
                    0,
                    -105px
                )
                rotateY(-7deg)
                scale(.96)
              `;


    const incomingTransform =
        forward
            ? `
                translate3d(
                    12%,
                    0,
                    -105px
                )
                rotateY(-7deg)
                scale(.96)
              `
            : `
                translate3d(
                    -12%,
                    0,
                    -105px
                )
                rotateY(7deg)
                scale(.96)
              `;



    nextImage.style.zIndex =
        "3";


    currentImage.style.zIndex =
        "2";



    const outgoingAnimation =
        currentImage.animate(
            [
                {
                    opacity: 1,

                    transform:
                        `
                        translate3d(
                            0,
                            0,
                            0
                        )
                        rotateY(0deg)
                        scale(1)
                        `
                },

                {
                    opacity: .1,

                    transform:
                        outgoingTransform
                }
            ],
            {
                duration: 680,

                easing:
                    "cubic-bezier(.22, 1, .36, 1)",

                fill:
                    "forwards"
            }
        );



    const incomingAnimation =
        nextImage.animate(
            [
                {
                    opacity: .15,

                    transform:
                        incomingTransform
                },

                {
                    opacity: 1,

                    transform:
                        `
                        translate3d(
                            0,
                            0,
                            0
                        )
                        rotateY(0deg)
                        scale(1)
                        `
                }
            ],
            {
                duration: 720,

                easing:
                    "cubic-bezier(.22, 1, .36, 1)",

                fill:
                    "forwards"
            }
        );



    /* ======================================================
       COPY MOTION
    ====================================================== */

    let copyOutAnimation =
        null;


    if (
        currentCopy &&
        currentCopy !== nextCopy
    ) {

        copyOutAnimation =
            currentCopy.animate(
                [
                    {
                        opacity: 1,

                        transform:
                            "translateX(0)"
                    },

                    {
                        opacity: 0,

                        transform:
                            forward
                                ? "translateX(-12px)"
                                : "translateX(12px)"
                    }
                ],
                {
                    duration: 300,

                    easing:
                        "ease",

                    fill:
                        "forwards"
                }
            );

    }



    const copyInAnimation =
        nextCopy.animate(
            [
                {
                    opacity: 0,

                    transform:
                        forward
                            ? "translateX(14px)"
                            : "translateX(-14px)"
                },

                {
                    opacity: 1,

                    transform:
                        "translateX(0)"
                }
            ],
            {
                duration: 620,

                delay: 0,

                easing:
                    "cubic-bezier(.22, 1, .36, 1)",

                fill:
                    "forwards"
            }
        );



    /* ======================================================
       FINISH
    ====================================================== */

    Promise.allSettled(
        [
            outgoingAnimation.finished,
            incomingAnimation.finished,
            copyInAnimation.finished,

            copyOutAnimation
                ? copyOutAnimation.finished
                : Promise.resolve()
        ]
    ).then(() => {


        placementImages.forEach(
            (image) => {

                image.classList.toggle(
                    "is-active",
                    image === nextImage
                );

            }
        );


        placementCopies.forEach(
            (copy) => {

                const active =
                    copy === nextCopy;


                copy.hidden =
                    !active;


                copy.classList.toggle(
                    "is-active",
                    active
                );

            }
        );


        outgoingAnimation.cancel();

        incomingAnimation.cancel();

        copyInAnimation.cancel();


        if (copyOutAnimation) {
            copyOutAnimation.cancel();
        }


        currentImage.style.zIndex =
            "";


        nextImage.style.zIndex =
            "";


        placementImageTransitioning =
            false;



        /* ----------------------------------------------
           FAST USER CLICK
        ---------------------------------------------- */

        if (queuedPlacement) {

            const queued =
                queuedPlacement;


            queuedPlacement =
                null;


            if (
                queued !==
                nextImage.dataset.placementImage
            ) {

                activatePlacement(
                    queued
                );

            }

        }

    });

}




    /* ======================================================
       PLACEMENT CLICK
    ====================================================== */

    placementPins.forEach(
        (pin) => {

            pin.setAttribute(
                "aria-pressed",
                pin.classList.contains(
                    "is-active"
                )
                    ? "true"
                    : "false"
            );


            bgListen(pin,
                "click",
                () => {

                    activatePlacement(
                        pin.dataset
                            .placementTarget
                    );

                }
            );

        }
    );



    /* ======================================================
       DEFAULT PLACEMENT
    ====================================================== */

    const initialPlacement =
        placementPins.find(
            (pin) =>
                pin.classList.contains(
                    "is-active"
                )
        ) ||
        placementPins[0];


    if (initialPlacement) {

        activatePlacement(
            initialPlacement.dataset
                .placementTarget
        );

    }



    /* ======================================================
       03 — MAKEUP CHAPTER ACTIVE STATE
    ====================================================== */

    const chapterLinks =
        Array.from(
            document.querySelectorAll(
                ".bgp-makeup-chapter"
            )
        );


    chapterLinks.forEach(
        (chapter) => {

            bgListen(chapter,
                "click",
                () => {

                    chapterLinks.forEach(
                        (item) => {

                            item.classList.remove(
                                "is-active"
                            );

                            item.removeAttribute(
                                "aria-current"
                            );

                        }
                    );


                    chapter.classList.add(
                        "is-active"
                    );


                    chapter.setAttribute(
                        "aria-current",
                        "true"
                    );

                }
            );

        }
    );

})();

/* ==========================================================
   RENEORA ORBIT CAROUSEL
   Premium 3D + Touch + Swipe + Mouse
========================================================== */

(() => {

    const carousels =
        document.querySelectorAll(
            "[data-orbit-carousel]"
        );

    if (!carousels.length) {
        return;
    }


    carousels.forEach((carousel) => {

        const stage =
            carousel.querySelector(
                ".bgp-orbit-stage"
            );

        const slides =
            Array.from(
                carousel.querySelectorAll(
                    "[data-orbit-slide]"
                )
            );

        const previousButton =
            carousel.querySelector(
                "[data-orbit-prev]"
            );

        const nextButton =
            carousel.querySelector(
                "[data-orbit-next]"
            );

        const currentCounter =
            carousel.querySelector(
                "[data-orbit-current]"
            );

        const totalCounter =
            carousel.querySelector(
                "[data-orbit-total]"
            );


        if (!stage || !slides.length) {
            return;
        }


        /* =====================================================
           STATE
        ===================================================== */

        let activeIndex = 0;

        let pointerActive = false;

        let pointerId = null;

        let pointerStartX = 0;

        let pointerStartY = 0;

        let pointerStartTime = 0;

        let gestureDirection = null;

        let swipeHappened = false;



        /* =====================================================
           HELPERS
        ===================================================== */

        function formatNumber(number) {

            return String(number).padStart(
                2,
                "0"
            );

        }


        function isInteractiveElement(target) {

            return Boolean(
                target.closest(
                    `
                    summary,
                    details,
                    a,
                    button,
                    input,
                    select,
                    textarea,
                    video
                    `
                )
            );

        }



        /* =====================================================
           RENDER
        ===================================================== */

        function renderOrbit() {

            const count =
                slides.length;


            slides.forEach(
                (slide, index) => {

                    slide.classList.remove(
                        "is-active",
                        "is-prev",
                        "is-next",
                        "is-hidden"
                    );


                    const difference =
                        (
                            index -
                            activeIndex +
                            count
                        ) %
                        count;


                    /* ACTIVE */

                    if (difference === 0) {

                        slide.classList.add(
                            "is-active"
                        );

                        slide.setAttribute(
                            "aria-hidden",
                            "false"
                        );

                        slide.tabIndex = 0;

                        return;
                    }


                    /* NEXT */

                    if (difference === 1) {

                        slide.classList.add(
                            "is-next"
                        );

                        slide.setAttribute(
                            "aria-hidden",
                            "true"
                        );

                        slide.tabIndex = -1;

                        return;
                    }


                    /* PREVIOUS */

                    if (
                        difference ===
                        count - 1
                    ) {

                        slide.classList.add(
                            "is-prev"
                        );

                        slide.setAttribute(
                            "aria-hidden",
                            "true"
                        );

                        slide.tabIndex = -1;

                        return;
                    }


                    /* HIDDEN */

                    slide.classList.add(
                        "is-hidden"
                    );

                    slide.setAttribute(
                        "aria-hidden",
                        "true"
                    );

                    slide.tabIndex = -1;

                }
            );


            /* COUNTER */

            if (currentCounter) {

                currentCounter.textContent =
                    formatNumber(
                        activeIndex + 1
                    );

            }


            if (totalCounter) {

                totalCounter.textContent =
                    formatNumber(
                        slides.length
                    );

            }


            /* CLOSE DISCOVER MORE
               ON NON-ACTIVE CARDS */

            slides.forEach(
                (slide, index) => {

                    if (index === activeIndex) {
                        return;
                    }

                    slide
                        .querySelectorAll(
                            "details[open]"
                        )
                        .forEach((details) => {

                            details.open = false;

                        });

                }
            );

        }



        /* =====================================================
           NAVIGATION
        ===================================================== */

        function nextSlide() {

            activeIndex =
                (
                    activeIndex + 1
                ) %
                slides.length;

            renderOrbit();

        }


        function previousSlide() {

            activeIndex =
                (
                    activeIndex -
                    1 +
                    slides.length
                ) %
                slides.length;

            renderOrbit();

        }



        /* =====================================================
           BUTTON CONTROLS
        ===================================================== */

        if (nextButton) {

            bgListen(nextButton,
                "click",
                nextSlide
            );

        }


        if (previousButton) {

            bgListen(previousButton,
                "click",
                previousSlide
            );

        }



        /* =====================================================
           SIDE CARD CLICK
        ===================================================== */

        slides.forEach((slide) => {

            bgListen(slide,
                "click",
                (event) => {

                    /*
                     * Do not interfere with
                     * Discover More / links / buttons.
                     */

                    if (
                        isInteractiveElement(
                            event.target
                        )
                    ) {
                        return;
                    }


                    /*
                     * Prevent a second navigation
                     * immediately after a swipe.
                     */

                    if (swipeHappened) {

                        swipeHappened = false;

                        return;
                    }


                    if (
                        slide.classList.contains(
                            "is-next"
                        )
                    ) {

                        nextSlide();

                        return;
                    }


                    if (
                        slide.classList.contains(
                            "is-prev"
                        )
                    ) {

                        previousSlide();

                    }

                }
            );

        });



        /* =====================================================
           KEYBOARD
        ===================================================== */

        bgListen(stage,
            "keydown",
            (event) => {

                if (
                    event.key ===
                    "ArrowRight"
                ) {

                    event.preventDefault();

                    nextSlide();

                }


                if (
                    event.key ===
                    "ArrowLeft"
                ) {

                    event.preventDefault();

                    previousSlide();

                }

            }
        );



        /* =====================================================
           PREMIUM SWIPE
           PHONE / TABLET / TOUCH LAPTOP / PEN / MOUSE
        ===================================================== */

        bgListen(stage,
            "pointerdown",
            (event) => {

                /*
                 * IMPORTANT:
                 * Discover More and other controls
                 * keep their native click behaviour.
                 */

                if (
                    isInteractiveElement(
                        event.target
                    )
                ) {

                    pointerActive = false;

                    return;
                }


                pointerActive = true;

                pointerId =
                    event.pointerId;

                pointerStartX =
                    event.clientX;

                pointerStartY =
                    event.clientY;

                pointerStartTime =
                    performance.now();

                gestureDirection = null;

                swipeHappened = false;

            }
        );



        bgListen(stage,
            "pointermove",
            (event) => {

                if (
                    !pointerActive ||
                    event.pointerId !==
                    pointerId
                ) {
                    return;
                }


                const deltaX =
                    event.clientX -
                    pointerStartX;

                const deltaY =
                    event.clientY -
                    pointerStartY;


                /*
                 * Wait for a few pixels
                 * before deciding the gesture.
                 */

                if (!gestureDirection) {

                    if (
                        Math.abs(deltaX) < 7 &&
                        Math.abs(deltaY) < 7
                    ) {
                        return;
                    }


                    if (
                        Math.abs(deltaX) >
                        Math.abs(deltaY) *
                        1.08
                    ) {

                        gestureDirection =
                            "horizontal";


                        stage.classList.add(
                            "is-dragging"
                        );


                        /*
                         * Capture only AFTER
                         * confirming a horizontal swipe.
                         *
                         * This avoids breaking
                         * Discover More on desktop.
                         */

                        try {

                            stage.setPointerCapture(
                                event.pointerId
                            );

                        } catch (error) {
                            /* No action needed */
                        }

                    } else {

                        gestureDirection =
                            "vertical";

                    }

                }


                /*
                 * Horizontal movement belongs
                 * to the Orbit, not page scrolling.
                 */

                if (
                    gestureDirection ===
                    "horizontal"
                ) {

                    event.preventDefault();

                }

            },
            {
                passive: false
            }
        );



        function finishPointerGesture(
            event
        ) {

            if (
                !pointerActive ||
                event.pointerId !==
                pointerId
            ) {
                return;
            }


            const deltaX =
                event.clientX -
                pointerStartX;

            const deltaY =
                event.clientY -
                pointerStartY;

            const elapsed =
                Math.max(
                    1,
                    performance.now() -
                    pointerStartTime
                );

            const horizontalDistance =
                Math.abs(deltaX);

            const velocity =
                horizontalDistance /
                elapsed;


            pointerActive = false;

            pointerId = null;

            stage.classList.remove(
                "is-dragging"
            );


            /*
             * A vertical gesture remains
             * normal page/card scrolling.
             */

            if (
                gestureDirection ===
                "vertical"
            ) {

                gestureDirection = null;

                return;
            }


            /*
             * Much easier on narrow phones:
             *
             * - 24px drag, OR
             * - quick horizontal flick.
             */

            const enoughDistance =
                horizontalDistance >= 24;

            const fastFlick =
                horizontalDistance >= 14 &&
                velocity >= 0.24;


            /*
             * Avoid interpreting mostly
             * vertical movement as swipe.
             */

            const horizontalEnough =
                horizontalDistance >
                Math.abs(deltaY) *
                0.9;


            if (
                !horizontalEnough ||
                (
                    !enoughDistance &&
                    !fastFlick
                )
            ) {

                gestureDirection = null;

                return;
            }


            swipeHappened = true;


            if (deltaX < 0) {

                nextSlide();

            } else {

                previousSlide();

            }


            gestureDirection = null;


            /*
             * Prevent the following synthetic click
             * from navigating one more slide.
             */

            bgTimeout(
                () => {

                    swipeHappened = false;

                },
                350
            );

        }



        bgListen(stage,
            "pointerup",
            finishPointerGesture
        );


        bgListen(stage,
            "pointercancel",
            () => {

                pointerActive = false;

                pointerId = null;

                gestureDirection = null;

                stage.classList.remove(
                    "is-dragging"
                );

            }
        );



        /* =====================================================
           DISCOVER MORE — PROTECT NATIVE INTERACTION
        ===================================================== */

        carousel
            .querySelectorAll(
                ".bgp-discover-more"
            )
            .forEach((details) => {

                bgListen(details,
                    "pointerdown",
                    (event) => {

                        event.stopPropagation();

                    }
                );


                bgListen(details,
                    "click",
                    (event) => {

                        event.stopPropagation();

                    }
                );

            });



        /* =====================================================
           INITIALIZE
        ===================================================== */

        renderOrbit();

    });

})();


/* ==========================================================
   RENEORA CHEEKS
   PREMIUM SCENE SHIFT
========================================================== */

(() => {

    const initCheeksGuide = () => {

        const cheeks =
            document.querySelector(
                "[data-premium-cheeks]"
            );


        if (!cheeks) {
            return;
        }


        const tabs =
            Array.from(
                cheeks.querySelectorAll(
                    "[data-cheeks-tab]"
                )
            );


        const panels =
            Array.from(
                cheeks.querySelectorAll(
                    "[data-cheeks-panel]"
                )
            );


        const panelsStage =
            cheeks.querySelector(
                ".bgp-cheeks-panels"
            );


        if (
            !tabs.length ||
            !panels.length ||
            !panelsStage
        ) {
            return;
        }



        let transitionRunning =
            false;


        let queuedTab =
            null;



        function activateCheeksTab(
            tabName,
            options = {}
        ) {

            const {
                focus = false,
                scrollTab = false
            } = options;


            const nextPanel =
                panels.find(
                    (panel) =>
                        panel.dataset.cheeksPanel ===
                        tabName
                );


            if (!nextPanel) {
                return;
            }



            /* ==============================================
               TAB BUTTON STATE
            ============================================== */

            tabs.forEach((tab) => {

                const active =
                    tab.dataset.cheeksTab ===
                    tabName;


                tab.classList.toggle(
                    "is-active",
                    active
                );


                tab.setAttribute(
                    "aria-selected",
                    active
                        ? "true"
                        : "false"
                );


                tab.tabIndex =
                    active
                        ? 0
                        : -1;


                if (
                    active &&
                    focus
                ) {

                    tab.focus({
                        preventScroll: true
                    });

                }


                if (
                    active &&
                    scrollTab
                ) {

                    tab.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                        inline: "center"
                    });

                }

            });



            /* ==============================================
               CURRENT PANEL
            ============================================== */

            const currentPanel =
                panels.find(
                    (panel) =>
                        !panel.hidden &&
                        panel.classList.contains(
                            "is-active"
                        )
                ) ||
                panels.find(
                    (panel) =>
                        !panel.hidden
                );



            /* INITIAL / SAME TAB */

            if (
                !currentPanel ||
                currentPanel === nextPanel
            ) {

                panels.forEach((panel) => {

                    const active =
                        panel === nextPanel;


                    panel.hidden =
                        !active;


                    panel.classList.toggle(
                        "is-active",
                        active
                    );


                    panel.setAttribute(
                        "aria-hidden",
                        active
                            ? "false"
                            : "true"
                    );

                });


                return;
            }



            /* ==============================================
               QUEUE FAST CLICKS
            ============================================== */

            if (transitionRunning) {

                queuedTab =
                    tabName;

                return;
            }


            transitionRunning =
                true;



            /* ==============================================
               DIRECTION
            ============================================== */

            const currentIndex =
                panels.indexOf(
                    currentPanel
                );


            const nextIndex =
                panels.indexOf(
                    nextPanel
                );


            const direction =
                nextIndex > currentIndex
                    ? "forward"
                    : "backward";



            /* ==============================================
               REDUCED MOTION
            ============================================== */

            const reduceMotion =
                window.matchMedia(
                    "(prefers-reduced-motion: reduce)"
                ).matches;


            if (reduceMotion) {

                currentPanel.hidden =
                    true;


                currentPanel.classList.remove(
                    "is-active"
                );


                nextPanel.hidden =
                    false;


                nextPanel.classList.add(
                    "is-active"
                );


                transitionRunning =
                    false;


                return;
            }



            /* ==============================================
               MEASURE
            ============================================== */

            const currentHeight =
                currentPanel.offsetHeight;


            nextPanel.hidden =
                false;


            nextPanel.style.visibility =
                "hidden";


            const nextHeight =
                nextPanel.offsetHeight;


            nextPanel.style.visibility =
                "";



            panelsStage.style.height =
                `${Math.max(
                    currentHeight,
                    nextHeight
                )}px`;


            panelsStage.classList.add(
                "is-scene-transitioning"
            );



            /* ==============================================
               3D ROLES
            ============================================== */

            currentPanel.classList.remove(
                "is-active"
            );


            currentPanel.classList.add(
                "is-scene-layer",
                "is-scene-leaving",
                `is-scene-${direction}`
            );


            nextPanel.classList.add(
                "is-scene-layer",
                "is-scene-entering",
                `is-scene-${direction}`
            );



            currentPanel
                .querySelectorAll("video")
                .forEach((video) => {

                    video.pause();

                });



            /* Force initial state */

            void panelsStage.offsetWidth;



            requestAnimationFrame(() => {

                requestAnimationFrame(() => {

                    panelsStage.classList.add(
                        "is-scene-playing"
                    );

                });

            });



            /* ==============================================
               FINISH
            ============================================== */

            bgTimeout(() => {

                currentPanel.hidden =
                    true;


                currentPanel.setAttribute(
                    "aria-hidden",
                    "true"
                );


                currentPanel.classList.remove(
                    "is-scene-layer",
                    "is-scene-leaving",
                    "is-scene-forward",
                    "is-scene-backward"
                );


                nextPanel.classList.remove(
                    "is-scene-layer",
                    "is-scene-entering",
                    "is-scene-forward",
                    "is-scene-backward"
                );


                nextPanel.classList.add(
                    "is-active"
                );


                nextPanel.setAttribute(
                    "aria-hidden",
                    "false"
                );


                panelsStage.classList.remove(
                    "is-scene-transitioning",
                    "is-scene-playing"
                );


                panelsStage.style.height =
                    "";


                transitionRunning =
                    false;



                if (queuedTab) {

                    const queued =
                        queuedTab;


                    queuedTab =
                        null;


                    if (
                        queued !==
                        nextPanel.dataset.cheeksPanel
                    ) {

                        activateCheeksTab(
                            queued
                        );

                    }

                }

            }, 400);

        }



        /* ==================================================
           CLICK
        ================================================== */

        tabs.forEach((tab) => {

            bgListen(tab,
                "click",
                () => {

                    activateCheeksTab(
                        tab.dataset.cheeksTab,
                        {
                            scrollTab: true
                        }
                    );

                }
            );

        });



        /* ==================================================
           KEYBOARD
        ================================================== */

        tabs.forEach((tab, index) => {

            bgListen(tab,
                "keydown",
                (event) => {

                    let nextIndex =
                        index;


                    if (
                        event.key ===
                        "ArrowRight"
                    ) {

                        nextIndex =
                            (
                                index + 1
                            ) %
                            tabs.length;

                    }


                    else if (
                        event.key ===
                        "ArrowLeft"
                    ) {

                        nextIndex =
                            (
                                index - 1 +
                                tabs.length
                            ) %
                            tabs.length;

                    }


                    else if (
                        event.key ===
                        "Home"
                    ) {

                        nextIndex =
                            0;

                    }


                    else if (
                        event.key ===
                        "End"
                    ) {

                        nextIndex =
                            tabs.length - 1;

                    }


                    else {

                        return;

                    }


                    event.preventDefault();


                    activateCheeksTab(
                        tabs[nextIndex]
                            .dataset
                            .cheeksTab,
                        {
                            focus: true,
                            scrollTab: true
                        }
                    );

                }
            );

        });



        /* ==================================================
           INITIAL STATE
        ================================================== */

        const initialTab =
            tabs.find(
                (tab) =>
                    tab.classList.contains(
                        "is-active"
                    )
            ) ||
            tabs[0];


        if (initialTab) {

            activateCheeksTab(
                initialTab.dataset.cheeksTab
            );

        }

    };



    if (
        document.readyState ===
        "loading"
    ) {

        bgListen(document,
            "DOMContentLoaded",
            initCheeksGuide,
            {
                once: true
            }
        );

    } else {

        initCheeksGuide();

    }

})();

/* ==========================================================
   RENEORA CHEEKS
   INTERACTIVE PLACEMENT
========================================================== */

(() => {

    const initCheeksPlacement = () => {

        const cheeks =
            document.querySelector(
                "[data-premium-cheeks]"
            );


        if (!cheeks) {
            return;
        }


        const buttons =
            Array.from(
                cheeks.querySelectorAll(
                    "[data-cheeks-placement-target]"
                )
            );


        const images =
            Array.from(
                cheeks.querySelectorAll(
                    "[data-cheeks-placement-image]"
                )
            );


        const copies =
            Array.from(
                cheeks.querySelectorAll(
                    "[data-cheeks-placement-copy]"
                )
            );


        if (
            !buttons.length ||
            !images.length ||
            !copies.length
        ) {
            return;
        }



        let transitioning =
            false;


        let queuedPlacement =
            null;



        const activatePlacement =
            (placementName) => {

                const nextButton =
                    buttons.find(
                        (button) =>
                            button.dataset
                                .cheeksPlacementTarget ===
                            placementName
                    );


                const nextImage =
                    images.find(
                        (image) =>
                            image.dataset
                                .cheeksPlacementImage ===
                            placementName
                    );


                const nextCopy =
                    copies.find(
                        (copy) =>
                            copy.dataset
                                .cheeksPlacementCopy ===
                            placementName
                    );


                if (
                    !nextButton ||
                    !nextImage ||
                    !nextCopy
                ) {
                    return;
                }



                const currentImage =
                    images.find(
                        (image) =>
                            image.classList.contains(
                                "is-active"
                            )
                    );


                const currentCopy =
                    copies.find(
                        (copy) =>
                            !copy.hidden &&
                            copy.classList.contains(
                                "is-active"
                            )
                    ) ||
                    copies.find(
                        (copy) =>
                            !copy.hidden
                    );



                /* ==========================================
                   SAME / INITIAL
                ========================================== */

                if (
                    !currentImage ||
                    currentImage === nextImage
                ) {

                    buttons.forEach(
                        (button) => {

                            const active =
                                button ===
                                nextButton;


                            button.classList.toggle(
                                "is-active",
                                active
                            );


                            button.setAttribute(
                                "aria-pressed",
                                active
                                    ? "true"
                                    : "false"
                            );

                        }
                    );


                    images.forEach(
                        (image) => {

                            image.classList.toggle(
                                "is-active",
                                image ===
                                    nextImage
                            );

                        }
                    );


                    copies.forEach(
                        (copy) => {

                            const active =
                                copy ===
                                nextCopy;


                            copy.hidden =
                                !active;


                            copy.classList.toggle(
                                "is-active",
                                active
                            );

                        }
                    );


                    return;
                }



                /* ==========================================
                   QUEUE FAST CLICKS
                ========================================== */

                if (transitioning) {

                    queuedPlacement =
                        placementName;

                    return;
                }


                transitioning =
                    true;



                /* ==========================================
                   BUTTON STATE
                ========================================== */

                buttons.forEach(
                    (button) => {

                        const active =
                            button ===
                            nextButton;


                        button.classList.toggle(
                            "is-active",
                            active
                        );


                        button.setAttribute(
                            "aria-pressed",
                            active
                                ? "true"
                                : "false"
                        );

                    }
                );



                /* ==========================================
                   DIRECTION
                ========================================== */

                const currentIndex =
                    images.indexOf(
                        currentImage
                    );


                const nextIndex =
                    images.indexOf(
                        nextImage
                    );


                const forward =
                    nextIndex >
                    currentIndex;



                /* ==========================================
                   PREPARE NEXT
                ========================================== */

                nextCopy.hidden =
                    false;


                nextCopy.classList.add(
                    "is-active"
                );


                nextImage.style.zIndex =
                    "4";


                currentImage.style.zIndex =
                    "3";



                const imageFromX =
                    forward
                        ? "9%"
                        : "-9%";


                const imageOutX =
                    forward
                        ? "-7%"
                        : "7%";


                const copyFromX =
                    forward
                        ? "34px"
                        : "-34px";


                const copyOutX =
                    forward
                        ? "-25px"
                        : "25px";



                /* ==========================================
                   IMAGE MOTION
                ========================================== */

                const outgoingImage =
                    currentImage.animate(
                        [
                            {
                                opacity: 1,

                                transform:
                                    "translate3d(0,0,0) rotateY(0deg) scale(1)"
                            },

                            {
                                opacity: 0,

                                transform:
                                    `translate3d(${imageOutX},0,-65px) rotateY(${forward ? "4deg" : "-4deg"}) scale(.985)`
                            }
                        ],
                        {
                            duration: 670,

                            easing:
                                "cubic-bezier(.22,1,.36,1)",

                            fill:
                                "forwards"
                        }
                    );


                const incomingImage =
                    nextImage.animate(
                        [
                            {
                                opacity: 0,

                                transform:
                                    `translate3d(${imageFromX},0,-80px) rotateY(${forward ? "-5deg" : "5deg"}) scale(.985)`
                            },

                            {
                                opacity: 1,

                                transform:
                                    "translate3d(0,0,0) rotateY(0deg) scale(1)"
                            }
                        ],
                        {
                            duration: 780,

                            easing:
                                "cubic-bezier(.22,1,.36,1)",

                            fill:
                                "forwards"
                        }
                    );



                /* ==========================================
                   COPY MOTION
                ========================================== */

                let outgoingCopy =
                    null;


                if (
                    currentCopy &&
                    currentCopy !==
                        nextCopy
                ) {

                    outgoingCopy =
                        currentCopy.animate(
                            [
                                {
                                    opacity: 1,

                                    transform:
                                        "translate3d(0,0,0)"
                                },

                                {
                                    opacity: 0,

                                    transform:
                                        `translate3d(${copyOutX},0,-20px)`
                                }
                            ],
                            {
                                duration: 420,

                                easing:
                                    "cubic-bezier(.22,1,.36,1)",

                                fill:
                                    "forwards"
                            }
                        );

                }


                const incomingCopy =
                    nextCopy.animate(
                        [
                            {
                                opacity: 0,

                                transform:
                                    `translate3d(${copyFromX},0,-24px)`
                            },

                            {
                                opacity: 1,

                                transform:
                                    "translate3d(0,0,0)"
                            }
                        ],
                        {
                            duration: 620,

                            delay: 0,

                            easing:
                                "cubic-bezier(.22,1,.36,1)",

                            fill:
                                "forwards"
                        }
                    );



                /* ==========================================
                   FINISH
                ========================================== */

                Promise.all(
                    [
                        outgoingImage.finished,
                        incomingImage.finished,
                        incomingCopy.finished,

                        outgoingCopy
                            ? outgoingCopy.finished
                            : Promise.resolve()
                    ]
                )
                .then(() => {

                    currentImage.classList.remove(
                        "is-active"
                    );


                    nextImage.classList.add(
                        "is-active"
                    );


                    images.forEach(
                        (image) => {

                            if (
                                image !==
                                nextImage
                            ) {

                                image.classList.remove(
                                    "is-active"
                                );

                            }


                            image.style.zIndex =
                                "";

                        }
                    );


                    copies.forEach(
                        (copy) => {

                            const active =
                                copy ===
                                nextCopy;


                            copy.hidden =
                                !active;


                            copy.classList.toggle(
                                "is-active",
                                active
                            );

                        }
                    );


                    outgoingImage.cancel();
                    incomingImage.cancel();
                    incomingCopy.cancel();


                    if (outgoingCopy) {
                        outgoingCopy.cancel();
                    }


                    transitioning =
                        false;



                    if (queuedPlacement) {

                        const queued =
                            queuedPlacement;


                        queuedPlacement =
                            null;


                        if (
                            queued !==
                            placementName
                        ) {

                            activatePlacement(
                                queued
                            );

                        }

                    }

                });

            };



        /* ==============================================
           CLICK
        ============================================== */

        buttons.forEach(
            (button) => {

                bgListen(button,
                    "click",
                    () => {

                        activatePlacement(
                            button.dataset
                                .cheeksPlacementTarget
                        );

                    }
                );

            }
        );



        /* ==============================================
           INITIAL
        ============================================== */

        const initial =
            buttons.find(
                (button) =>
                    button.classList.contains(
                        "is-active"
                    )
            ) ||
            buttons[0];


        if (initial) {

            activatePlacement(
                initial.dataset
                    .cheeksPlacementTarget
            );

        }

    };



    if (
        document.readyState ===
        "loading"
    ) {

        bgListen(document,
            "DOMContentLoaded",
            initCheeksPlacement,
            {
                once: true
            }
        );

    } else {

        initCheeksPlacement();

    }

})();

/* ==========================================================
   RENEORA LIPS
   PREMIUM SCENE SHIFT
========================================================== */

(() => {

    const initLipsGuide = () => {

        const lips =
            document.querySelector(
                "[data-premium-lips]"
            );


        if (!lips) {
            return;
        }


        const tabs =
            Array.from(
                lips.querySelectorAll(
                    "[data-lips-tab]"
                )
            );


        const panels =
            Array.from(
                lips.querySelectorAll(
                    "[data-lips-panel]"
                )
            );


        const stage =
            lips.querySelector(
                ".bgp-lips-panels"
            );


        if (
            !tabs.length ||
            !panels.length ||
            !stage
        ) {
            return;
        }


        let transitioning = false;
        let queuedTab = null;


        const preloadPanelImages = panelName => {

            const panel =
                panels.find(
                    item =>
                        item.dataset.lipsPanel ===
                        panelName
                );


            if (!panel) {
                return;
            }


            return Promise.all(
                Array.from(
                    panel.querySelectorAll(
                        "img"
                    )
                )
                .map(image => {

                    image.loading = "eager";


                    if (
                        typeof image.decode ===
                        "function"
                    ) {

                        return image.decode().catch(
                            () => {}
                        );
                    }

                    return Promise.resolve();
                })
            );
        };


        if (
            "IntersectionObserver" in window
        ) {

            const lipsPreloadObserver =
                bgObserver(
                    entries => {

                        if (
                            !entries.some(
                                entry =>
                                    entry.isIntersecting
                            )
                        ) {
                            return;
                        }


                        preloadPanelImages(
                            "layering"
                        );


                        lipsPreloadObserver.disconnect();
                    },
                    {
                        rootMargin:
                            "600px 0px"
                    }
                );


            lipsPreloadObserver.observe(
                lips
            );

        }



        const activateTab = async (
            tabName,
            options = {}
        ) => {

            const {
                focus = false,
                scrollTab = false
            } = options;


            const nextPanel =
                panels.find(
                    panel =>
                        panel.dataset.lipsPanel ===
                        tabName
                );


            if (!nextPanel) {
                return;
            }


            if (
                tabName === "layering"
            ) {

                await preloadPanelImages(
                    "layering"
                );
            }



            tabs.forEach(tab => {

                const active =
                    tab.dataset.lipsTab ===
                    tabName;


                tab.classList.toggle(
                    "is-active",
                    active
                );


                tab.setAttribute(
                    "aria-selected",
                    active
                        ? "true"
                        : "false"
                );


                tab.tabIndex =
                    active
                        ? 0
                        : -1;


                if (
                    active &&
                    focus
                ) {

                    tab.focus({
                        preventScroll: true
                    });

                }


                if (
                    active &&
                    scrollTab
                ) {

                    tab.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                        inline: "center"
                    });

                }

            });



            const currentPanel =
                panels.find(
                    panel =>
                        !panel.hidden &&
                        panel.classList.contains(
                            "is-active"
                        )
                ) ||
                panels.find(
                    panel =>
                        !panel.hidden
                );



            if (
                !currentPanel ||
                currentPanel === nextPanel
            ) {

                panels.forEach(panel => {

                    const active =
                        panel === nextPanel;


                    panel.hidden =
                        !active;


                    panel.classList.toggle(
                        "is-active",
                        active
                    );


                    panel.setAttribute(
                        "aria-hidden",
                        active
                            ? "false"
                            : "true"
                    );

                });


                return;
            }



            if (transitioning) {

                queuedTab =
                    tabName;

                return;
            }


            transitioning = true;



            const currentIndex =
                panels.indexOf(
                    currentPanel
                );


            const nextIndex =
                panels.indexOf(
                    nextPanel
                );


            const direction =
                nextIndex > currentIndex
                    ? "forward"
                    : "backward";



            const reduceMotion =
                window.matchMedia(
                    "(prefers-reduced-motion: reduce)"
                ).matches;


            if (reduceMotion) {

                currentPanel.hidden = true;

                currentPanel.classList.remove(
                    "is-active"
                );


                nextPanel.hidden = false;

                nextPanel.classList.add(
                    "is-active"
                );


                transitioning = false;

                return;
            }



            const currentHeight =
                currentPanel.offsetHeight;


            nextPanel.hidden = false;

            nextPanel.style.visibility =
                "hidden";


            const nextHeight =
                nextPanel.offsetHeight;


            nextPanel.style.visibility =
                "";



            stage.style.height =
                `${Math.max(
                    currentHeight,
                    nextHeight
                )}px`;


            stage.classList.add(
                "is-scene-transitioning"
            );



            currentPanel.classList.remove(
                "is-active"
            );


            currentPanel.classList.add(
                "is-scene-layer",
                "is-scene-leaving",
                `is-scene-${direction}`
            );


            nextPanel.classList.add(
                "is-scene-layer",
                "is-scene-entering",
                `is-scene-${direction}`
            );



            currentPanel
                .querySelectorAll("video")
                .forEach(video => {

                    video.pause();

                });



            void stage.offsetWidth;



            requestAnimationFrame(() => {

                requestAnimationFrame(() => {

                    stage.classList.add(
                        "is-scene-playing"
                    );

                });

            });



            bgTimeout(() => {

                currentPanel.hidden =
                    true;


                currentPanel.setAttribute(
                    "aria-hidden",
                    "true"
                );


                currentPanel.classList.remove(
                    "is-scene-layer",
                    "is-scene-leaving",
                    "is-scene-forward",
                    "is-scene-backward"
                );


                nextPanel.classList.remove(
                    "is-scene-layer",
                    "is-scene-entering",
                    "is-scene-forward",
                    "is-scene-backward"
                );


                nextPanel.classList.add(
                    "is-active"
                );


                nextPanel.setAttribute(
                    "aria-hidden",
                    "false"
                );


                stage.classList.remove(
                    "is-scene-transitioning",
                    "is-scene-playing"
                );


                stage.style.height = "";


                transitioning = false;



                if (queuedTab) {

                    const queued =
                        queuedTab;


                    queuedTab = null;


                    if (
                        queued !==
                        nextPanel.dataset.lipsPanel
                    ) {

                        activateTab(
                            queued
                        );

                    }

                }

            }, 400);

        };



        tabs.forEach(tab => {

            const preloadTab = () => {

                preloadPanelImages(
                    tab.dataset.lipsTab
                );
            };


            bgListen(tab,
                "pointerenter",
                preloadTab,
                {
                    once: true
                }
            );


            bgListen(tab,
                "focus",
                preloadTab,
                {
                    once: true
                }
            );


            bgListen(tab,
                "touchstart",
                preloadTab,
                {
                    once: true,
                    passive: true
                }
            );

            bgListen(tab,
                "click",
                () => {

                    activateTab(
                        tab.dataset.lipsTab,
                        {
                            scrollTab: true
                        }
                    );

                }
            );

        });



        tabs.forEach(
            (tab, index) => {

                bgListen(tab,
                    "keydown",
                    event => {

                        let nextIndex =
                            index;


                        if (
                            event.key ===
                            "ArrowRight"
                        ) {

                            nextIndex =
                                (
                                    index + 1
                                ) %
                                tabs.length;

                        }

                        else if (
                            event.key ===
                            "ArrowLeft"
                        ) {

                            nextIndex =
                                (
                                    index - 1 +
                                    tabs.length
                                ) %
                                tabs.length;

                        }

                        else if (
                            event.key ===
                            "Home"
                        ) {

                            nextIndex = 0;

                        }

                        else if (
                            event.key ===
                            "End"
                        ) {

                            nextIndex =
                                tabs.length - 1;

                        }

                        else {

                            return;

                        }


                        event.preventDefault();


                        activateTab(
                            tabs[nextIndex]
                                .dataset
                                .lipsTab,
                            {
                                focus: true,
                                scrollTab: true
                            }
                        );

                    }
                );

            }
        );



        const initialTab =
            tabs.find(
                tab =>
                    tab.classList.contains(
                        "is-active"
                    )
            ) ||
            tabs[0];


        if (initialTab) {

            activateTab(
                initialTab.dataset.lipsTab
            );

        }

    };



    if (
        document.readyState ===
        "loading"
    ) {

        bgListen(document,
            "DOMContentLoaded",
            initLipsGuide,
            {
                once: true
            }
        );

    } else {

        initLipsGuide();

    }

})();

/* ==========================================================
   RENEORA LIPS
   INTERACTIVE PLACEMENT
========================================================== */

(() => {

    const initLipsPlacement = () => {

        const lips =
            document.querySelector(
                "[data-premium-lips]"
            );


        if (!lips) {
            return;
        }


        const buttons =
            Array.from(
                lips.querySelectorAll(
                    "[data-lips-placement-target]"
                )
            );


        const images =
            Array.from(
                lips.querySelectorAll(
                    "[data-lips-placement-image]"
                )
            );


        const copies =
            Array.from(
                lips.querySelectorAll(
                    "[data-lips-placement-copy]"
                )
            );


        if (
            !buttons.length ||
            !images.length ||
            !copies.length
        ) {
            return;
        }



        let transitioning = false;
        let queuedPlacement = null;



        const activatePlacement =
            (placementName) => {


                const nextButton =
                    buttons.find(
                        button =>
                            button.dataset
                                .lipsPlacementTarget ===
                            placementName
                    );


                const nextImage =
                    images.find(
                        image =>
                            image.dataset
                                .lipsPlacementImage ===
                            placementName
                    );


                const nextCopy =
                    copies.find(
                        copy =>
                            copy.dataset
                                .lipsPlacementCopy ===
                            placementName
                    );


                if (
                    !nextButton ||
                    !nextImage ||
                    !nextCopy
                ) {
                    return;
                }



                const currentImage =
                    images.find(
                        image =>
                            image.classList.contains(
                                "is-active"
                            )
                    );


                const currentCopy =
                    copies.find(
                        copy =>
                            !copy.hidden &&
                            copy.classList.contains(
                                "is-active"
                            )
                    ) ||
                    copies.find(
                        copy =>
                            !copy.hidden
                    );



                /* SAME / INITIAL */

                if (
                    !currentImage ||
                    currentImage === nextImage
                ) {

                    buttons.forEach(button => {

                        const active =
                            button === nextButton;


                        button.classList.toggle(
                            "is-active",
                            active
                        );


                        button.setAttribute(
                            "aria-pressed",
                            active
                                ? "true"
                                : "false"
                        );

                    });


                    images.forEach(image => {

                        image.classList.toggle(
                            "is-active",
                            image === nextImage
                        );

                    });


                    copies.forEach(copy => {

                        const active =
                            copy === nextCopy;


                        copy.hidden =
                            !active;


                        copy.classList.toggle(
                            "is-active",
                            active
                        );

                    });


                    return;
                }



                if (transitioning) {

                    queuedPlacement =
                        placementName;

                    return;
                }


                transitioning = true;



                /* BUTTON */

                buttons.forEach(button => {

                    const active =
                        button === nextButton;


                    button.classList.toggle(
                        "is-active",
                        active
                    );


                    button.setAttribute(
                        "aria-pressed",
                        active
                            ? "true"
                            : "false"
                    );

                });



                const currentIndex =
                    images.indexOf(
                        currentImage
                    );


                const nextIndex =
                    images.indexOf(
                        nextImage
                    );


                const forward =
                    nextIndex >
                    currentIndex;



                nextCopy.hidden = false;

                nextCopy.classList.add(
                    "is-active"
                );


                nextImage.style.zIndex = "4";

                currentImage.style.zIndex = "3";



                const imageFromX =
                    forward
                        ? "9%"
                        : "-9%";


                const imageOutX =
                    forward
                        ? "-7%"
                        : "7%";


                const copyFromX =
                    forward
                        ? "34px"
                        : "-34px";


                const copyOutX =
                    forward
                        ? "-25px"
                        : "25px";



                /* IMAGE */

                const outgoingImage =
                    currentImage.animate(
                        [
                            {
                                opacity: 1,

                                transform:
                                    "translate3d(0,0,0) rotateY(0deg) scale(1)"
                            },

                            {
                                opacity: 0,

                                transform:
                                    `translate3d(${imageOutX},0,-65px) rotateY(${forward ? "4deg" : "-4deg"}) scale(.985)`
                            }
                        ],
                        {
                            duration: 670,

                            easing:
                                "cubic-bezier(.22,1,.36,1)",

                            fill:
                                "forwards"
                        }
                    );


                const incomingImage =
                    nextImage.animate(
                        [
                            {
                                opacity: 0,

                                transform:
                                    `translate3d(${imageFromX},0,-80px) rotateY(${forward ? "-5deg" : "5deg"}) scale(.985)`
                            },

                            {
                                opacity: 1,

                                transform:
                                    "translate3d(0,0,0) rotateY(0deg) scale(1)"
                            }
                        ],
                        {
                            duration: 780,

                            easing:
                                "cubic-bezier(.22,1,.36,1)",

                            fill:
                                "forwards"
                        }
                    );



                /* COPY */

                let outgoingCopy = null;


                if (
                    currentCopy &&
                    currentCopy !== nextCopy
                ) {

                    outgoingCopy =
                        currentCopy.animate(
                            [
                                {
                                    opacity: 1,

                                    transform:
                                        "translate3d(0,0,0)"
                                },

                                {
                                    opacity: 0,

                                    transform:
                                        `translate3d(${copyOutX},0,-20px)`
                                }
                            ],
                            {
                                duration: 420,

                                easing:
                                    "cubic-bezier(.22,1,.36,1)",

                                fill:
                                    "forwards"
                            }
                        );

                }


                const incomingCopy =
                    nextCopy.animate(
                        [
                            {
                                opacity: 0,

                                transform:
                                    `translate3d(${copyFromX},0,-24px)`
                            },

                            {
                                opacity: 1,

                                transform:
                                    "translate3d(0,0,0)"
                            }
                        ],
                        {
                            duration: 620,

                            easing:
                                "cubic-bezier(.22,1,.36,1)",

                            fill:
                                "forwards"
                        }
                    );



                Promise.all(
                    [
                        outgoingImage.finished,
                        incomingImage.finished,
                        incomingCopy.finished,

                        outgoingCopy
                            ? outgoingCopy.finished
                            : Promise.resolve()
                    ]
                )
                .then(() => {


                    images.forEach(image => {

                        const active =
                            image === nextImage;


                        image.classList.toggle(
                            "is-active",
                            active
                        );


                        image.style.zIndex = "";

                    });


                    copies.forEach(copy => {

                        const active =
                            copy === nextCopy;


                        copy.hidden =
                            !active;


                        copy.classList.toggle(
                            "is-active",
                            active
                        );

                    });



                    outgoingImage.cancel();
                    incomingImage.cancel();
                    incomingCopy.cancel();


                    if (outgoingCopy) {
                        outgoingCopy.cancel();
                    }


                    transitioning = false;



                    if (queuedPlacement) {

                        const queued =
                            queuedPlacement;


                        queuedPlacement = null;


                        if (
                            queued !==
                            placementName
                        ) {

                            activatePlacement(
                                queued
                            );

                        }

                    }

                });

            };



        buttons.forEach(button => {

            bgListen(button,
                "click",
                () => {

                    activatePlacement(
                        button.dataset
                            .lipsPlacementTarget
                    );

                }
            );

        });



        const initial =
            buttons.find(
                button =>
                    button.classList.contains(
                        "is-active"
                    )
            ) ||
            buttons[0];


        if (initial) {

            activatePlacement(
                initial.dataset
                    .lipsPlacementTarget
            );

        }

    };



    if (
        document.readyState ===
        "loading"
    ) {

        bgListen(document,
            "DOMContentLoaded",
            initLipsPlacement,
            {
                once: true
            }
        );

    } else {

        initLipsPlacement();

    }

})();

/* ==========================================================
   RENEORA EYES
   PREMIUM SCENE SHIFT
========================================================== */

(() => {

    const initEyesGuide = () => {

        const eyes =
            document.querySelector(
                "[data-premium-eyes]"
            );


        if (!eyes) {
            return;
        }


        const tabs =
            Array.from(
                eyes.querySelectorAll(
                    "[data-eyes-tab]"
                )
            );


        const panels =
            Array.from(
                eyes.querySelectorAll(
                    "[data-eyes-panel]"
                )
            );


        const stage =
            eyes.querySelector(
                ".bgp-eyes-panels"
            );


        if (
            !tabs.length ||
            !panels.length ||
            !stage
        ) {
            return;
        }


        let transitionRunning =
            false;

        let queuedTab =
            null;



        const activateEyesTab =
            (tabName) => {


                const nextPanel =
                    panels.find(
                        panel =>
                            panel.dataset
                                .eyesPanel ===
                            tabName
                    );


                if (!nextPanel) {
                    return;
                }


                const currentPanel =
                    panels.find(
                        panel =>
                            !panel.hidden &&
                            panel.classList.contains(
                                "is-active"
                            )
                    ) ||
                    panels.find(
                        panel =>
                            !panel.hidden
                    );


                tabs.forEach(tab => {

                    const active =
                        tab.dataset
                            .eyesTab ===
                        tabName;


                    tab.classList.toggle(
                        "is-active",
                        active
                    );


                    tab.setAttribute(
                        "aria-selected",
                        active
                            ? "true"
                            : "false"
                    );

                });



                if (
                    !currentPanel ||
                    currentPanel === nextPanel
                ) {

                    panels.forEach(panel => {

                        const active =
                            panel === nextPanel;


                        panel.hidden =
                            !active;


                        panel.classList.toggle(
                            "is-active",
                            active
                        );

                    });


                    return;
                }



                if (transitionRunning) {

                    queuedTab =
                        tabName;

                    return;
                }


                transitionRunning =
                    true;



                const currentIndex =
                    panels.indexOf(
                        currentPanel
                    );


                const nextIndex =
                    panels.indexOf(
                        nextPanel
                    );


                const direction =
                    nextIndex > currentIndex
                        ? "forward"
                        : "backward";



                const currentHeight =
                    currentPanel.offsetHeight;


                nextPanel.hidden =
                    false;


                nextPanel.style.visibility =
                    "hidden";


                const nextHeight =
                    nextPanel.offsetHeight;


                nextPanel.style.visibility =
                    "";


                stage.style.height =
                    `${Math.max(
                        currentHeight,
                        nextHeight
                    )}px`;



                stage.classList.add(
                    "is-scene-transitioning"
                );


                currentPanel.classList.remove(
                    "is-active"
                );


                currentPanel.classList.add(
                    "is-scene-layer",
                    "is-scene-leaving",
                    `is-scene-${direction}`
                );


                nextPanel.classList.add(
                    "is-scene-layer",
                    "is-scene-entering",
                    `is-scene-${direction}`
                );



                currentPanel
                    .querySelectorAll("video")
                    .forEach(video => {

                        video.pause();

                    });



                requestAnimationFrame(() => {

                    requestAnimationFrame(() => {

                        stage.classList.add(
                            "is-scene-playing"
                        );

                    });

                });



                bgTimeout(() => {

                    currentPanel.hidden =
                        true;


                    currentPanel.classList.remove(
                        "is-scene-layer",
                        "is-scene-leaving",
                        "is-scene-forward",
                        "is-scene-backward"
                    );


                    nextPanel.classList.remove(
                        "is-scene-layer",
                        "is-scene-entering",
                        "is-scene-forward",
                        "is-scene-backward"
                    );


                    nextPanel.classList.add(
                        "is-active"
                    );


                    stage.classList.remove(
                        "is-scene-transitioning",
                        "is-scene-playing"
                    );


                    stage.style.height =
                        "";


                    transitionRunning =
                        false;



                    if (queuedTab) {

                        const queued =
                            queuedTab;


                        queuedTab =
                            null;


                        if (
                            queued !==
                            nextPanel.dataset
                                .eyesPanel
                        ) {

                            activateEyesTab(
                                queued
                            );

                        }

                    }

                }, 400);

            };



        tabs.forEach(tab => {

            bgListen(tab,
                "click",
                () => {

                    activateEyesTab(
                        tab.dataset
                            .eyesTab
                    );

                }
            );

        });



        tabs.forEach(
            (tab, index) => {

                bgListen(tab,
                    "keydown",
                    event => {

                        let nextIndex =
                            index;


                        if (
                            event.key ===
                            "ArrowRight"
                        ) {

                            nextIndex =
                                (
                                    index + 1
                                ) %
                                tabs.length;

                        }

                        else if (
                            event.key ===
                            "ArrowLeft"
                        ) {

                            nextIndex =
                                (
                                    index - 1 +
                                    tabs.length
                                ) %
                                tabs.length;

                        }

                        else {

                            return;

                        }


                        event.preventDefault();


                        tabs[nextIndex]
                            .focus();


                        activateEyesTab(
                            tabs[nextIndex]
                                .dataset
                                .eyesTab
                        );

                    }
                );

            }
        );

    };



    if (
        document.readyState ===
        "loading"
    ) {

        bgListen(document,
            "DOMContentLoaded",
            initEyesGuide,
            {
                once: true
            }
        );

    } else {

        initEyesGuide();

    }

})();

/* ==========================================================
   RENEORA EYES
   INTERACTIVE PLACEMENT
========================================================== */

(() => {

    const initEyesPlacement = () => {

        const root =
            document.querySelector(
                "[data-eyes-placement]"
            );


        if (!root) {
            return;
        }


        const buttons =
            Array.from(
                root.querySelectorAll(
                    "[data-eyes-placement-target]"
                )
            );


        const images =
            Array.from(
                root.querySelectorAll(
                    "[data-eyes-placement-image]"
                )
            );


        const copies =
            Array.from(
                root.querySelectorAll(
                    "[data-eyes-placement-copy]"
                )
            );


        if (
            !buttons.length ||
            !images.length ||
            !copies.length
        ) {
            return;
        }



        let transitioning =
            false;

        let queuedState =
            null;



        const setButtonState =
            activeButton => {

                buttons.forEach(button => {

                    const active =
                        button ===
                        activeButton;


                    button.classList.toggle(
                        "is-active",
                        active
                    );


                    button.setAttribute(
                        "aria-pressed",
                        active
                            ? "true"
                            : "false"
                    );

                });

            };



        const activate =
            async state => {


                const nextButton =
                    buttons.find(
                        button =>
                            button.dataset
                                .eyesPlacementTarget ===
                            state
                    );


                const nextImage =
                    images.find(
                        image =>
                            image.dataset
                                .eyesPlacementImage ===
                            state
                    );


                const nextCopy =
                    copies.find(
                        copy =>
                            copy.dataset
                                .eyesPlacementCopy ===
                            state
                    );


                if (
                    !nextButton ||
                    !nextImage ||
                    !nextCopy
                ) {
                    return;
                }



                if (transitioning) {

                    queuedState =
                        state;

                    return;
                }



                const currentImage =
                    images.find(
                        image =>
                            image.classList.contains(
                                "is-active"
                            )
                    );


                const currentCopy =
                    copies.find(
                        copy =>
                            !copy.hidden &&
                            copy.classList.contains(
                                "is-active"
                            )
                    ) ||
                    copies.find(
                        copy =>
                            !copy.hidden
                    );



                setButtonState(
                    nextButton
                );



                /* INITIAL OR SAME STATE */

                if (
                    !currentImage ||
                    currentImage === nextImage
                ) {

                    images.forEach(image => {

                        image.classList.toggle(
                            "is-active",
                            image === nextImage
                        );

                    });


                    copies.forEach(copy => {

                        const active =
                            copy === nextCopy;


                        copy.hidden =
                            !active;


                        copy.classList.toggle(
                            "is-active",
                            active
                        );

                    });


                    return;
                }



                transitioning =
                    true;



                const currentIndex =
                    images.indexOf(
                        currentImage
                    );


                const nextIndex =
                    images.indexOf(
                        nextImage
                    );


                const forward =
                    nextIndex >
                    currentIndex;



                nextCopy.hidden =
                    false;


                nextCopy.classList.add(
                    "is-active"
                );


                nextImage.style.zIndex =
                    "4";


                currentImage.style.zIndex =
                    "3";



                const imageFromX =
                    forward
                        ? "8%"
                        : "-8%";


                const imageOutX =
                    forward
                        ? "-6%"
                        : "6%";


                const copyFromX =
                    forward
                        ? "32px"
                        : "-32px";


                const copyOutX =
                    forward
                        ? "-24px"
                        : "24px";



                /* IMAGE OUT */

                const outgoingImage =
                    currentImage.animate(
                        [
                            {
                                opacity: 1,

                                transform:
                                    "translate3d(0,0,0) rotateY(0deg) scale(1.025)"
                            },

                            {
                                opacity: 0,

                                transform:
                                    `translate3d(${imageOutX},0,-70px) rotateY(${forward ? "4deg" : "-4deg"}) scale(1.01)`
                            }
                        ],
                        {
                            duration:
                                650,

                            easing:
                                "cubic-bezier(.22,1,.36,1)",

                            fill:
                                "forwards"
                        }
                    );



                /* IMAGE IN */

                const incomingImage =
                    nextImage.animate(
                        [
                            {
                                opacity: 0,

                                transform:
                                    `translate3d(${imageFromX},0,-85px) rotateY(${forward ? "-5deg" : "5deg"}) scale(1.01)`
                            },

                            {
                                opacity: 1,

                                transform:
                                    "translate3d(0,0,0) rotateY(0deg) scale(1.025)"
                            }
                        ],
                        {
                            duration:
                                760,

                            easing:
                                "cubic-bezier(.22,1,.36,1)",

                            fill:
                                "forwards"
                        }
                    );



                /* COPY OUT */

                let outgoingCopy =
                    null;


                if (
                    currentCopy &&
                    currentCopy !== nextCopy
                ) {

                    outgoingCopy =
                        currentCopy.animate(
                            [
                                {
                                    opacity: 1,

                                    transform:
                                        "translate3d(0,0,0)"
                                },

                                {
                                    opacity: 0,

                                    transform:
                                        `translate3d(${copyOutX},0,-18px)`
                                }
                            ],
                            {
                                duration:
                                    400,

                                easing:
                                    "cubic-bezier(.22,1,.36,1)",

                                fill:
                                    "forwards"
                            }
                        );

                }



                /* COPY IN */

                const incomingCopy =
                    nextCopy.animate(
                        [
                            {
                                opacity: 0,

                                transform:
                                    `translate3d(${copyFromX},0,-22px)`
                            },

                            {
                                opacity: 1,

                                transform:
                                    "translate3d(0,0,0)"
                            }
                        ],
                        {
                            duration:
                                590,

                            easing:
                                "cubic-bezier(.22,1,.36,1)",

                            fill:
                                "forwards"
                        }
                    );



                await Promise.allSettled(
                    [
                        outgoingImage.finished,
                        incomingImage.finished,
                        incomingCopy.finished,

                        outgoingCopy
                            ? outgoingCopy.finished
                            : Promise.resolve()
                    ]
                );



                images.forEach(image => {

                    const active =
                        image === nextImage;


                    image.classList.toggle(
                        "is-active",
                        active
                    );


                    image.style.zIndex =
                        "";

                });



                copies.forEach(copy => {

                    const active =
                        copy === nextCopy;


                    copy.hidden =
                        !active;


                    copy.classList.toggle(
                        "is-active",
                        active
                    );

                });



                outgoingImage.cancel();
                incomingImage.cancel();
                incomingCopy.cancel();


                if (outgoingCopy) {
                    outgoingCopy.cancel();
                }



                transitioning =
                    false;



                if (queuedState) {

                    const queued =
                        queuedState;


                    queuedState =
                        null;


                    if (queued !== state) {

                        activate(
                            queued
                        );

                    }

                }

            };



        /* CLICK */

        buttons.forEach(button => {

            bgListen(button,
                "click",
                () => {

                    activate(
                        button.dataset
                            .eyesPlacementTarget
                    );

                }
            );

        });



        /* KEYBOARD */

        buttons.forEach(
            (button, index) => {

                bgListen(button,
                    "keydown",
                    event => {

                        let nextIndex =
                            index;


                        if (
                            event.key ===
                            "ArrowDown" ||
                            event.key ===
                            "ArrowRight"
                        ) {

                            nextIndex =
                                (
                                    index + 1
                                ) %
                                buttons.length;

                        }

                        else if (
                            event.key ===
                            "ArrowUp" ||
                            event.key ===
                            "ArrowLeft"
                        ) {

                            nextIndex =
                                (
                                    index - 1 +
                                    buttons.length
                                ) %
                                buttons.length;

                        }

                        else if (
                            event.key ===
                            "Home"
                        ) {

                            nextIndex =
                                0;

                        }

                        else if (
                            event.key ===
                            "End"
                        ) {

                            nextIndex =
                                buttons.length - 1;

                        }

                        else {

                            return;

                        }


                        event.preventDefault();


                        buttons[nextIndex]
                            .focus();


                        activate(
                            buttons[nextIndex]
                                .dataset
                                .eyesPlacementTarget
                        );

                    }
                );

            }
        );



        /* INITIAL */

        const initialButton =
            buttons.find(
                button =>
                    button.classList.contains(
                        "is-active"
                    )
            ) ||
            buttons[0];


        if (initialButton) {

            activate(
                initialButton.dataset
                    .eyesPlacementTarget
            );

        }

    };



    if (
        document.readyState ===
        "loading"
    ) {

        bgListen(document,
            "DOMContentLoaded",
            initEyesPlacement,
            {
                once: true
            }
        );

    } else {

        initEyesPlacement();

    }

})();

/* ==========================================================
   RENEORA SKINCARE
   PREMIUM SCENE SHIFT
========================================================== */

(() => {

    const initPremiumSkincare = () => {

        const skincare =
            document.querySelector(
                "[data-premium-skincare]"
            );


        if (!skincare) {
            return;
        }


        const tabs =
            Array.from(
                skincare.querySelectorAll(
                    "[data-skincare-tab]"
                )
            );


        const panels =
            Array.from(
                skincare.querySelectorAll(
                    "[data-skincare-panel]"
                )
            );


        const stage =
            skincare.querySelector(
                ".bgp-skincare-panels"
            );


        if (
            !tabs.length ||
            !panels.length ||
            !stage
        ) {
            return;
        }


        let transitioning =
            false;

        let queuedTab =
            null;



        const activate =
            tabName => {


                const nextPanel =
                    panels.find(
                        panel =>
                            panel.dataset
                                .skincarePanel ===
                            tabName
                    );


                if (!nextPanel) {
                    return;
                }


                const currentPanel =
                    panels.find(
                        panel =>
                            !panel.hidden &&
                            panel.classList.contains(
                                "is-active"
                            )
                    ) ||
                    panels.find(
                        panel =>
                            !panel.hidden
                    );


                if (
                    currentPanel === nextPanel
                ) {

                    tabs.forEach(tab => {

                        const active =
                            tab.dataset
                                .skincareTab ===
                            tabName;


                        tab.classList.toggle(
                            "is-active",
                            active
                        );


                        tab.setAttribute(
                            "aria-selected",
                            active
                                ? "true"
                                : "false"
                        );

                    });


                    return;
                }



                if (transitioning) {

                    queuedTab =
                        tabName;

                    return;
                }



                tabs.forEach(tab => {

                    const active =
                        tab.dataset
                            .skincareTab ===
                        tabName;


                    tab.classList.toggle(
                        "is-active",
                        active
                    );


                    tab.setAttribute(
                        "aria-selected",
                        active
                            ? "true"
                            : "false"
                    );

                });



                if (!currentPanel) {

                    nextPanel.hidden =
                        false;


                    nextPanel.classList.add(
                        "is-active"
                    );


                    return;
                }



                transitioning =
                    true;



                const currentIndex =
                    panels.indexOf(
                        currentPanel
                    );


                const nextIndex =
                    panels.indexOf(
                        nextPanel
                    );


                const direction =
                    nextIndex >
                    currentIndex
                        ? "forward"
                        : "backward";



                const currentHeight =
                    currentPanel.offsetHeight;


                nextPanel.hidden =
                    false;


                nextPanel.style.visibility =
                    "hidden";


                const nextHeight =
                    nextPanel.offsetHeight;


                nextPanel.style.visibility =
                    "";


                stage.style.height =
                    `${Math.max(
                        currentHeight,
                        nextHeight
                    )}px`;



                stage.classList.add(
                    "is-scene-transitioning"
                );


                currentPanel.classList.remove(
                    "is-active"
                );


                currentPanel.classList.add(
                    "is-scene-layer",
                    "is-scene-leaving",
                    `is-scene-${direction}`
                );


                nextPanel.classList.add(
                    "is-scene-layer",
                    "is-scene-entering",
                    `is-scene-${direction}`
                );



                currentPanel
                    .querySelectorAll("video")
                    .forEach(video => {

                        video.pause();

                    });



                requestAnimationFrame(() => {

                    requestAnimationFrame(() => {

                        stage.classList.add(
                            "is-scene-playing"
                        );

                    });

                });



                bgTimeout(() => {


                    currentPanel.hidden =
                        true;


                    currentPanel.classList.remove(
                        "is-scene-layer",
                        "is-scene-leaving",
                        "is-scene-forward",
                        "is-scene-backward"
                    );


                    nextPanel.classList.remove(
                        "is-scene-layer",
                        "is-scene-entering",
                        "is-scene-forward",
                        "is-scene-backward"
                    );


                    nextPanel.classList.add(
                        "is-active"
                    );


                    stage.classList.remove(
                        "is-scene-transitioning",
                        "is-scene-playing"
                    );


                    stage.style.height =
                        "";


                    transitioning =
                        false;



                    if (queuedTab) {

                        const queued =
                            queuedTab;


                        queuedTab =
                            null;


                        if (
                            queued !==
                            nextPanel.dataset
                                .skincarePanel
                        ) {

                            activate(
                                queued
                            );

                        }

                    }

                }, 400);

            };



        tabs.forEach(tab => {

            bgListen(tab,
                "click",
                () => {

                    activate(
                        tab.dataset
                            .skincareTab
                    );

                }
            );

        });



        tabs.forEach(
            (tab,index) => {

                bgListen(tab,
                    "keydown",
                    event => {


                        let nextIndex =
                            index;


                        if (
                            event.key ===
                            "ArrowRight"
                        ) {

                            nextIndex =
                                (
                                    index + 1
                                ) %
                                tabs.length;

                        }

                        else if (
                            event.key ===
                            "ArrowLeft"
                        ) {

                            nextIndex =
                                (
                                    index - 1 +
                                    tabs.length
                                ) %
                                tabs.length;

                        }

                        else if (
                            event.key ===
                            "Home"
                        ) {

                            nextIndex =
                                0;

                        }

                        else if (
                            event.key ===
                            "End"
                        ) {

                            nextIndex =
                                tabs.length - 1;

                        }

                        else {

                            return;

                        }


                        event.preventDefault();


                        tabs[nextIndex]
                            .focus();


                        activate(
                            tabs[nextIndex]
                                .dataset
                                .skincareTab
                        );

                    }
                );

            }
        );

    };



    if (
        document.readyState ===
        "loading"
    ) {

        bgListen(document,
            "DOMContentLoaded",
            initPremiumSkincare,
            {
                once: true
            }
        );

    } else {

        initPremiumSkincare();

    }

})();

(() => {

    /* =====================================================
       RENEORA SHADE STUDIO
       FULL COVER FOUNDATION — PHASE 1
    ===================================================== */


   const page =
    document.querySelector(
        ".full-cover-foundation-product-page, " +
        ".concealer-product-page"
    );


    if (!page) {
        return;
    }


    /* =====================================================
       ORIGINAL RENEORA SHADE SYSTEM
    ===================================================== */

    const sourceExperience =
        page.querySelector(
            "[data-complexion-shades]"
        );


    if (!sourceExperience) {
        return;
    }


    const sourceSwatches =
        Array.from(
            sourceExperience.querySelectorAll(
                ".complexion-shade-swatch"
            )
        );


    if (!sourceSwatches.length) {
        return;
    }


    /* =====================================================
       STUDIO ELEMENTS
    ===================================================== */

    const studio =
        document.getElementById(
            "rsShadeStudio"
        );


    if (!studio) {
        return;
    }


    const isConcealerStudio =
        studio.dataset.rsProduct ===
        "concealer";


    const openButton =
        page.querySelector(
            "[data-rs-open]"
        );


    const closeButtons =
        studio.querySelectorAll(
            "[data-rs-close]"
        );


    const screens =
        studio.querySelectorAll(
            "[data-rs-screen]"
        );


    const progressBars =
        studio.querySelectorAll(
            ".rs-studio__progress span"
        );


    const areaButtons =
        studio.querySelectorAll(
            "[data-rs-area]"
        );


    const backButtons =
        studio.querySelectorAll(
            "[data-rs-back]"
        );


    const cameraButton =
        studio.querySelector(
            "[data-rs-camera]"
        );


    const uploadButton =
        studio.querySelector(
            "[data-rs-upload]"
        );


    const cameraInput =
        document.getElementById(
            "rsCameraInput"
        );


    const uploadInput =
        document.getElementById(
            "rsUploadInput"
        );


    const photo =
        document.getElementById(
            "rsStudioPhoto"
        );


    const shadeContainer =
        document.getElementById(
            "rsStudioShades"
        );


    const selectedShadeLabel =
        document.getElementById(
            "rsStudioSelectedShade"
        );


    const captureDescription =
        document.getElementById(
            "rsCaptureDescription"
        );

    const liveCamera = studio.querySelector("[data-rs-live-camera]");
    const liveVideo = studio.querySelector("[data-rs-live-video]");
    const liveGuide = studio.querySelector("[data-rs-live-guide]");
    const liveStatus = studio.querySelector("[data-rs-live-status]");
    const liveCapture = studio.querySelector("[data-rs-live-capture]");
    const liveCancel = studio.querySelector("[data-rs-live-cancel]");
    let liveStream = null;
    let liveFrame = 0;
    let liveAnalysisBusy = false;
    let lastLiveAnalysis = 0;


    const useShadeButton =
        studio.querySelector(
            "[data-rs-use-shade]"
        );


    const startOverButton =
        studio.querySelector(
            "[data-rs-start-over]"
        );


    /* =====================================================
       LOCAL SESSION STATE
    ===================================================== */

    const state = {

        screen: "area",

        area: null,

        photoURL: null,

        selectedShadeName: "",

        selectedShadeColor: ""

    };


    /* =====================================================
       CURRENT PRODUCT SHADE
    ===================================================== */

    function getCurrentSourceShade() {

        return (
            sourceExperience.querySelector(
                ".complexion-shade-swatch.is-active"
            ) ||
            sourceSwatches[0]
        );

    }


    /* =====================================================
       SELECT LOCAL STUDIO SHADE
    ===================================================== */

    function selectStudioShade(
        shadeName,
        shadeColor
    ) {

        state.selectedShadeName =
            shadeName;

        state.selectedShadeColor =
            shadeColor;


        selectedShadeLabel.textContent =
            shadeName;


        const studioShadeButtons =
            shadeContainer.querySelectorAll(
                ".rs-studio-shade"
            );


        studioShadeButtons.forEach(
            button => {

                const isCurrent =
                    button.dataset.shadeName ===
                    shadeName;


                button.classList.toggle(
                    "is-selected",
                    isCurrent
                );


                button.setAttribute(
                    "aria-pressed",
                    isCurrent
                        ? "true"
                        : "false"
                );

            }
        );


        /*
           Prepared for Phase 2:
           the realistic renderer will read these.
        */

        studio.style.setProperty(
            "--rs-active-shade",
            shadeColor
        );

        studio.dataset.rsShadeName =
    shadeName;

studio.dataset.rsShadeColor =
    shadeColor;


studio.dispatchEvent(
    new CustomEvent(
        "reneora:shadechange",
        {
            detail: {
                shadeName,
                shadeColor
            }
        }
    )
);

    }


    /* =====================================================
       BUILD SHADES FROM THE REAL PRODUCT PAGE
    ===================================================== */

    function buildStudioShades() {

        shadeContainer.innerHTML = "";


        sourceSwatches.forEach(
            sourceSwatch => {

                const shadeName =
                    sourceSwatch.dataset.shadeName;

                const shadeColor =
                    sourceSwatch.dataset.shadeColor;


                if (
                    !shadeName ||
                    !shadeColor
                ) {
                    return;
                }


                const button =
                    document.createElement(
                        "button"
                    );


                button.type =
                    "button";


                button.className =
                    "rs-studio-shade";


                button.dataset.shadeName =
                    shadeName;


                button.dataset.shadeColor =
                    shadeColor;


                button.style.setProperty(
                    "--rs-shade",
                    shadeColor
                );


                button.setAttribute(
                    "aria-label",
                    `Try ${shadeName}`
                );


                button.setAttribute(
                    "aria-pressed",
                    "false"
                );


                button.title =
                    shadeName;


                bgListen(button,
                    "click",
                    () => {

                        selectStudioShade(
                            shadeName,
                            shadeColor
                        );

                    }
                );


                shadeContainer.appendChild(
                    button
                );

            }
        );


        const current =
            getCurrentSourceShade();


        if (current) {

            selectStudioShade(
                current.dataset.shadeName,
                current.dataset.shadeColor
            );

        }

    }


    /* =====================================================
       SCREEN CONTROL
    ===================================================== */

    function showScreen(
        screenName
    ) {

        state.screen =
            screenName;


        screens.forEach(
            screen => {

                screen.classList.toggle(
                    "is-active",
                    screen.dataset.rsScreen ===
                    screenName
                );

            }
        );


        const order =
            isConcealerStudio
                ? {
                    capture: 1,
                    preview: 2
                }
                : {
                    area: 1,
                    capture: 2,
                    preview: 3
                };


        const currentStep =
            order[screenName] || 1;


        progressBars.forEach(
            (bar, index) => {

                bar.classList.toggle(
                    "is-active",
                    index < currentStep
                );

            }
        );

    }


    /* =====================================================
       OPEN
    ===================================================== */

    function openStudio() {

        buildStudioShades();

        if (
            isConcealerStudio
        ) {

            state.area =
                "both";


            studio.dataset.rsArea =
                "both";


            captureDescription.textContent =
                "Frame your full face clearly. Keep both eyes and both sides of your nose visible in soft natural light.";


            cameraInput.setAttribute(
                "capture",
                "user"
            );


            showScreen(
                "capture"
            );

        } else {

            showScreen(
                "area"
            );

        }


        studio.classList.add(
            "is-open"
        );


        studio.setAttribute(
            "aria-hidden",
            "false"
        );


        document.body.classList.add(
            "rs-studio-open"
        );


        document.body.style.overflow =
            "hidden";

    }


    /* =====================================================
       DELETE TEMPORARY PHOTO
    ===================================================== */

    function clearPhoto() {

        if (state.photoURL) {

            URL.revokeObjectURL(
                state.photoURL
            );

        }


        state.photoURL =
            null;


        photo.removeAttribute(
            "src"
        );


        cameraInput.value = "";
        uploadInput.value = "";

    }


    /* =====================================================
       CLOSE
    ===================================================== */

    function closeStudio() {

        stopGuidedCamera();

        studio.classList.remove(
            "is-open"
        );


        studio.setAttribute(
            "aria-hidden",
            "true"
        );


        document.body.classList.remove(
            "rs-studio-open"
        );


        document.body.style.overflow =
            "";


        /*
           Privacy by design:
           destroy the temporary browser image
           when the Shade Studio closes.
        */

        clearPhoto();


        state.area =
            isConcealerStudio
                ? "both"
                : null;


        showScreen(
            isConcealerStudio
                ? "capture"
                : "area"
        );

    }


    /* =====================================================
       AREA
    ===================================================== */

    function chooseArea(
        area
    ) {

        state.area =
            area;
studio.dataset.rsArea =
    area;

        if (
            area === "cheek"
        ) {

            captureDescription.textContent =
                "Frame one cheek closely in soft natural light. Avoid flash, filters and heavy makeup.";


            /*
               Front-facing camera preference.
            */

            cameraInput.setAttribute(
                "capture",
                "user"
            );

        }


        if (
            area === "hand"
        ) {

            captureDescription.textContent =
                "Place the back of your hand in soft natural light. Keep your hand relaxed and avoid direct flash.";


            /*
               Rear camera preference.
            */

            cameraInput.setAttribute(
                "capture",
                "environment"
            );

        }

if (
    area === "under-eye"
) {

    captureDescription.textContent =
        "Frame your full face clearly. Keep both eyes visible and look toward the camera in soft natural light.";

    cameraInput.setAttribute(
        "capture",
        "user"
    );

}


if (
    area === "nose"
) {

    captureDescription.textContent =
        "Frame your full face clearly with the nose and surrounding skin visible in soft natural light.";

    cameraInput.setAttribute(
        "capture",
        "user"
    );

}

        showScreen(
            "capture"
        );

    }


    /* =====================================================
       HANDLE LOCAL PHOTO
    ===================================================== */

    function handlePhoto(
        file
    ) {

        if (!file) {
            return;
        }


        if (
            !file.type.startsWith(
                "image/"
            )
        ) {
            return;
        }


        clearPhoto();


        state.photoURL =
            URL.createObjectURL(
                file
            );


        photo.src =
            state.photoURL;


        bgListen(photo,
            "load",
            () => {

                showScreen(
                    "preview"
                );

            },
            {
                once: true
            }
        );

    }

    function stopGuidedCamera() {
        cancelAnimationFrame(liveFrame);
        liveStream?.getTracks().forEach(track => track.stop());
        liveStream = null;
        if (liveVideo) liveVideo.srcObject = null;
        if (liveCamera) liveCamera.hidden = true;
        liveCapture?.setAttribute("disabled", "");
    }

    function drawLiveLandmarks(landmarks) {
        if (!liveGuide || !liveVideo || !landmarks) return;
        const width = liveGuide.clientWidth;
        const height = liveGuide.clientHeight;
        const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
        liveGuide.width = Math.round(width * ratio);
        liveGuide.height = Math.round(height * ratio);
        const context = liveGuide.getContext("2d");
        context.setTransform(ratio, 0, 0, ratio, 0, 0);
        context.clearRect(0, 0, width, height);

        const scale = Math.max(width / liveVideo.videoWidth, height / liveVideo.videoHeight);
        const offsetX = (width - liveVideo.videoWidth * scale) / 2;
        const offsetY = (height - liveVideo.videoHeight * scale) / 2;
        const point = index => ({
            x: width - (landmarks[index].x * liveVideo.videoWidth * scale + offsetX),
            y: landmarks[index].y * liveVideo.videoHeight * scale + offsetY
        });

        context.strokeStyle = "rgba(255,255,255,.95)";
        context.lineWidth = 2;
        context.lineCap = "round";
        context.setLineDash([6, 5]);

        [[33, 133, 145], [263, 362, 374]].forEach(([outerIndex, innerIndex, lowerIndex]) => {
            const outer = point(outerIndex);
            const inner = point(innerIndex);
            const lower = point(lowerIndex);
            const eyeWidth = Math.hypot(inner.x - outer.x, inner.y - outer.y);
            context.beginPath();
            context.moveTo(outer.x, outer.y + eyeWidth * .12);
            context.quadraticCurveTo(lower.x, lower.y + eyeWidth * .24, inner.x, inner.y + eyeWidth * .15);
            context.stroke();
        });

        const tip = point(1);
        const bridge = point(168);
        [98, 327].forEach(index => {
            const ala = point(index);
            const axisLength = Math.max(1, Math.hypot(tip.x - bridge.x, tip.y - bridge.y));
            const axisX = (tip.x - bridge.x) / axisLength;
            const axisY = (tip.y - bridge.y) / axisLength;
            let outX = -axisY;
            let outY = axisX;
            if (outX * (ala.x - tip.x) + outY * (ala.y - tip.y) < 0) {
                outX *= -1;
                outY *= -1;
            }
            const noseWidth = Math.hypot(point(98).x - point(327).x, point(98).y - point(327).y);
            const centerX = ala.x + outX * noseWidth * .13;
            const centerY = ala.y + outY * noseWidth * .13;
            context.beginPath();
            context.moveTo(centerX - axisX * noseWidth * .22, centerY - axisY * noseWidth * .22);
            context.quadraticCurveTo(
                centerX + outX * noseWidth * .10,
                centerY + outY * noseWidth * .10,
                centerX + axisX * noseWidth * .20,
                centerY + axisY * noseWidth * .20
            );
            context.stroke();
        });
    }

    async function monitorGuidedCamera(time) {
        if (!liveStream) return;
        liveFrame = requestAnimationFrame(monitorGuidedCamera);
        if (liveAnalysisBusy || time - lastLiveAnalysis < 420 || liveVideo.readyState < 2) return;
        lastLiveAnalysis = time;
        liveAnalysisBusy = true;

        try {
            const result = await window.ReneoraConcealerLiveGuide?.analyze(liveVideo);
            if (result) {
                liveStatus.textContent = result.title;
                liveCamera.classList.toggle("is-ready", result.valid);
                liveCapture.disabled = !result.valid;
                drawLiveLandmarks(result.landmarks);
            }
        } catch (error) {
            liveStatus.textContent = "Guidance is loading…";
        } finally {
            liveAnalysisBusy = false;
        }
    }

    async function startGuidedCamera() {
        if (!isConcealerStudio || !liveCamera || !liveVideo ||
            !navigator.mediaDevices?.getUserMedia || !window.isSecureContext) {
            cameraInput.click();
            return;
        }

        try {
            liveStream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "user", width: { ideal: 720 }, height: { ideal: 960 } },
                audio: false
            });
            liveVideo.srcObject = liveStream;
            liveCamera.hidden = false;
            await liveVideo.play();
            liveFrame = requestAnimationFrame(monitorGuidedCamera);
        } catch (error) {
            stopGuidedCamera();
            cameraInput.click();
        }
    }


    /* =====================================================
       OPEN BUTTON
    ===================================================== */

    openButton?.addEventListener(
        "click",
        openStudio
    );


    /* =====================================================
       CLOSE BUTTONS
    ===================================================== */

    closeButtons.forEach(
        button => {

            bgListen(button,
                "click",
                closeStudio
            );

        }
    );


    /* =====================================================
       AREA BUTTONS
    ===================================================== */

    areaButtons.forEach(
        button => {

            bgListen(button,
                "click",
                () => {

                    chooseArea(
                        button.dataset.rsArea
                    );

                }
            );

        }
    );


    /* =====================================================
       BACK
    ===================================================== */

    backButtons.forEach(
        button => {

            bgListen(button,
                "click",
                () => {

                    const target =
                        button.dataset.rsBack;


                    if (
                        target === "capture"
                    ) {

                        clearPhoto();

                    }


                    showScreen(
                        target
                    );

                }
            );

        }
    );


    /* =====================================================
       CAMERA
    ===================================================== */

    cameraButton?.addEventListener(
        "click",
        () => {

            startGuidedCamera();

        }
    );

    liveCancel?.addEventListener("click", stopGuidedCamera);

    liveCapture?.addEventListener("click", () => {
        if (!liveStream || liveCapture.disabled) return;
        const captureCanvas = document.createElement("canvas");
        captureCanvas.width = liveVideo.videoWidth;
        captureCanvas.height = liveVideo.videoHeight;
        const context = captureCanvas.getContext("2d");
        context.translate(captureCanvas.width, 0);
        context.scale(-1, 1);
        context.drawImage(liveVideo, 0, 0);
        captureCanvas.toBlob(blob => {
            if (!blob) return;
            stopGuidedCamera();
            handlePhoto(new File([blob], "reneora-concealer-photo.jpg", {
                type: "image/jpeg"
            }));
        }, "image/jpeg", .92);
    });


    cameraInput?.addEventListener(
        "change",
        event => {

            handlePhoto(
                event.target.files?.[0]
            );

        }
    );


    /* =====================================================
       UPLOAD
    ===================================================== */

    uploadButton?.addEventListener(
        "click",
        () => {

            uploadInput.click();

        }
    );


    uploadInput?.addEventListener(
        "change",
        event => {

            handlePhoto(
                event.target.files?.[0]
            );

        }
    );


    /* =====================================================
       USE THIS SHADE
    ===================================================== */

    useShadeButton?.addEventListener(
        "click",
        () => {

            const matchingSourceShade =
                sourceSwatches.find(
                    swatch => {

                        return (
                            swatch.dataset.shadeName ===
                            state.selectedShadeName
                        );

                    }
                );


            /*
               Only NOW do we send the choice
               back to the original Reneora product page.

               This means browsing shades inside
               Shade Studio does NOT fill the existing
               Compare Your Shades list.
            */

            matchingSourceShade?.click();


            closeStudio();

        }
    );


    /* =====================================================
       START OVER
    ===================================================== */

    startOverButton?.addEventListener(
        "click",
        () => {

            clearPhoto();

            state.area =
                isConcealerStudio
                    ? "both"
                    : null;

            showScreen(
                isConcealerStudio
                    ? "capture"
                    : "area"
            );

        }
    );


    /* =====================================================
       ESCAPE
    ===================================================== */

    bgListen(document,
        "keydown",
        event => {

            if (
                event.key === "Escape" &&
                studio.classList.contains(
                    "is-open"
                )
            ) {

                closeStudio();

            }

        }
    );

})();

/* ==========================================================
   RENEORA SKINCARE WATCH
   SIDE CARD + VIDEO SWIPE FIX
========================================================== */

(() => {

    const initSkincareWatchOrbitFix = () => {

        const orbit =
            document.querySelector(
                ".bgp-skincare-watch-orbit[data-orbit-carousel]"
            );


        if (!orbit) {
            return;
        }


        /* Prevent duplicate initialization */

        if (
            orbit.dataset
                .skincareWatchGestureFix ===
            "true"
        ) {
            return;
        }


        orbit.dataset
            .skincareWatchGestureFix =
            "true";


        const previousButton =
            orbit.querySelector(
                "[data-orbit-prev]"
            );


        const nextButton =
            orbit.querySelector(
                "[data-orbit-next]"
            );


        if (
            !previousButton ||
            !nextButton
        ) {
            return;
        }



        /* =================================================
           1 — SIDE CARD CLICK
        ================================================== */

        bgListen(orbit,
            "click",
            event => {


                /*
                 * Never interfere with
                 * the real Orbit arrows.
                 */

                if (
                    event.target.closest(
                        "[data-orbit-prev], [data-orbit-next]"
                    )
                ) {
                    return;
                }


                const slide =
                    event.target.closest(
                        "[data-orbit-slide]"
                    );


                if (
                    !slide ||
                    slide.classList.contains(
                        "is-active"
                    )
                ) {
                    return;
                }



                /* RIGHT SIDE CARD */

                if (
                    slide.classList.contains(
                        "is-next"
                    )
                ) {

                    event.preventDefault();
                    event.stopPropagation();

                    nextButton.click();

                    return;
                }



                /* LEFT SIDE CARD */

                if (
                    slide.classList.contains(
                        "is-prev"
                    )
                ) {

                    event.preventDefault();
                    event.stopPropagation();

                    previousButton.click();

                }

            },
            true
        );



        /* =================================================
           2 — SWIPE STARTING DIRECTLY ON VIDEO
        ================================================== */

        let gesture =
            null;


        const LOCK_DISTANCE =
            7;


        const SWIPE_DISTANCE =
            38;



        bgListen(orbit,
            "pointerdown",
            event => {


                /*
                 * Only add this special behavior
                 * when the gesture STARTS on
                 * the active video.
                 *
                 * The normal Orbit engine handles
                 * the rest of the card.
                 */

                const video =
                    event.target.closest(
                        ".bgp-skincare-watch-media video"
                    );


                if (!video) {
                    return;
                }


                const activeSlide =
                    video.closest(
                        "[data-orbit-slide]"
                    );


                if (
                    !activeSlide ||
                    !activeSlide.classList.contains(
                        "is-active"
                    )
                ) {
                    return;
                }


                if (!event.isPrimary) {
                    return;
                }


                gesture = {

                    pointerId:
                        event.pointerId,

                    startX:
                        event.clientX,

                    startY:
                        event.clientY,

                    lastX:
                        event.clientX,

                    direction:
                        null

                };

            },
            true
        );



        bgListen(orbit,
            "pointermove",
            event => {


                if (
                    !gesture ||
                    event.pointerId !==
                    gesture.pointerId
                ) {
                    return;
                }


                const deltaX =
                    event.clientX -
                    gesture.startX;


                const deltaY =
                    event.clientY -
                    gesture.startY;


                gesture.lastX =
                    event.clientX;



                /*
                 * Wait until the user clearly
                 * chooses horizontal or vertical.
                 */

                if (!gesture.direction) {

                    if (
                        Math.max(
                            Math.abs(deltaX),
                            Math.abs(deltaY)
                        ) <
                        LOCK_DISTANCE
                    ) {
                        return;
                    }


                    gesture.direction =
                        Math.abs(deltaX) >
                        Math.abs(deltaY)
                            ? "horizontal"
                            : "vertical";



                    /*
                     * Vertical = normal page scroll.
                     */

                    if (
                        gesture.direction ===
                        "vertical"
                    ) {
                        return;
                    }



                    /*
                     * Horizontal = Orbit owns
                     * the gesture from here.
                     */

                    try {

                        orbit.setPointerCapture(
                            event.pointerId
                        );

                    } catch (error) {

                        /* Safe fallback */

                    }

                }



                if (
                    gesture.direction ===
                    "horizontal"
                ) {

                    event.preventDefault();

                }

            },
            {
                capture:
                    true,

                passive:
                    false
            }
        );



        const finishGesture =
            event => {


                if (
                    !gesture ||
                    event.pointerId !==
                    gesture.pointerId
                ) {
                    return;
                }


                const deltaX =
                    event.clientX -
                    gesture.startX;


                const horizontal =
                    gesture.direction ===
                    "horizontal";


                gesture =
                    null;



                try {

                    if (
                        orbit.hasPointerCapture(
                            event.pointerId
                        )
                    ) {

                        orbit.releasePointerCapture(
                            event.pointerId
                        );

                    }

                } catch (error) {

                    /* Safe fallback */

                }



                if (
                    !horizontal ||
                    Math.abs(deltaX) <
                    SWIPE_DISTANCE
                ) {
                    return;
                }



                /*
                 * Swipe LEFT
                 * Morning → Evening
                 */

                if (deltaX < 0) {

                    nextButton.click();

                }



                /*
                 * Swipe RIGHT
                 * Evening → Morning
                 */

                else {

                    previousButton.click();

                }


                event.preventDefault();
                event.stopPropagation();

            };



        bgListen(orbit,
            "pointerup",
            finishGesture,
            true
        );


        bgListen(orbit,
            "pointercancel",
            event => {

                if (
                    gesture &&
                    event.pointerId ===
                    gesture.pointerId
                ) {

                    gesture =
                        null;

                }

            },
            true
        );

    };



    if (
        document.readyState ===
        "loading"
    ) {

        bgListen(document,
            "DOMContentLoaded",
            initSkincareWatchOrbitFix,
            {
                once: true
            }
        );

    } else {

        initSkincareWatchOrbitFix();

    }

})();
/* RENEORA — BEAUTY GUIDE IMAGE WARMUP

   Hidden guide panels normally do not request their lazy
   images until the panel becomes visible. Warm the first
   visual as a chapter approaches, then decode the complete
   target panel on hover, focus or touch before activation.
========================================================== */

(() => {

    if (!document.body.classList.contains(
        "reneora-beauty-guide-page"
    )) {
        return;
    }

    const chapterSelector = [
        "[data-premium-eyes]",
        "[data-premium-complexion]",
        "[data-premium-cheeks]",
        "[data-premium-lips]",
        "[data-premium-skincare]"
    ].join(",");

    const tabSelector = [
        "[data-eyes-tab]",
        "[data-complexion-tab]",
        "[data-cheeks-tab]",
        "[data-lips-tab]",
        "[data-skincare-tab]"
    ].join(",");

    const panelSelector = [
        "[data-eyes-panel]",
        "[data-complexion-panel]",
        "[data-cheeks-panel]",
        "[data-lips-panel]",
        "[data-skincare-panel]"
    ].join(",");

    const warmedImages = new WeakSet();

    const warmImage = image => {

        if (!image || warmedImages.has(image)) {
            return Promise.resolve();
        }

        warmedImages.add(image);
        image.loading = "eager";
        image.decoding = "async";

        if ("fetchPriority" in image) {
            image.fetchPriority = "low";
        }

        if (typeof image.decode === "function") {
            return image.decode().catch(() => {});
        }

        return Promise.resolve();
    };

    const warmPanel = (
        panel,
        firstVisualOnly = false
    ) => {

        if (!panel) {
            return;
        }

        const images = Array.from(
            panel.querySelectorAll("img")
        );

        const selection = firstVisualOnly
            ? images.slice(0, 1)
            : images;

        selection.forEach(warmImage);
    };

    const panelForTab = tab => {

        const panelId = tab.getAttribute(
            "aria-controls"
        );

        return panelId
            ? document.getElementById(panelId)
            : null;
    };

    document.querySelectorAll(tabSelector)
        .forEach(tab => {

            const prepareTargetPanel = () => {
                warmPanel(panelForTab(tab));
            };

            bgListen(tab,
                "pointerenter",
                prepareTargetPanel,
                { passive: true }
            );

            bgListen(tab,
                "focusin",
                prepareTargetPanel
            );

            bgListen(tab,
                "touchstart",
                prepareTargetPanel,
                { passive: true }
            );

            bgListen(tab,
                "pointerdown",
                prepareTargetPanel,
                { passive: true }
            );

        });

    const warmApproachingChapter = chapter => {

        const panels = Array.from(
            chapter.querySelectorAll(panelSelector)
        );

        panels.forEach(panel => {

            if (!panel.hidden) {
                warmPanel(panel);
                return;
            }

            warmPanel(panel, true);

        });
    };

    const chapters = document.querySelectorAll(
        chapterSelector
    );

    if (!("IntersectionObserver" in window)) {
        chapters.forEach(warmApproachingChapter);
        return;
    }

    const chapterObserver = bgObserver(
        entries => {

            entries.forEach(entry => {

                if (!entry.isIntersecting) {
                    return;
                }

                warmApproachingChapter(entry.target);
                chapterObserver.unobserve(entry.target);

            });

        },
        {
            rootMargin: "900px 0px",
            threshold: 0.01
        }
    );

    chapters.forEach(chapter => {
        chapterObserver.observe(chapter);
    });

})();

 }
 init();
 document.addEventListener('shopify:section:load',init);
 document.addEventListener('shopify:block:select',event=>{
  const slide=event.target.closest('[data-orbit-slide]');
  const panel=event.target.closest('[role="tabpanel"]');
  if(panel){const tab=document.getElementById(panel.getAttribute('aria-labelledby'));tab?.click();}
  if(slide)window.setTimeout(()=>slide.click(),600);
 });
})();
